import React, { Component, useState } from "react";
import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel,
  FormControl,
  Table,
  HelpBlock,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getAllLabPartners,
  getallrider,
  AddLabOrder,
  get_single_lead_data,
  searchLeadForOrder,
  getpagewiseHealthcondition,
  getCity,
  getCountry,
  AddReport,
  GetPackages,
  GetReports,
  GetDepartment,
  searchLablastsubscription,
  getLabOrdersbyid,
  SendQuoteLabOrder,
  Get_Settings_byid,
  getSalesRepresentative,
  getPolicyDetailsByPackgeId,
  getAvailableCreditsByLeads,
  getremaincreditforleaduser,
} from "../../../Listfunction";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";
import ScreenLoader from "views/Components/screenLoader";
import LoadingSpinner from "views/Components/loadingSpinner";
import "../../../assets/css/demo.css";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import Collapsible from "react-collapsible";

class addlaborder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      rider_idError: null,
      labPartnerOptions: [],
      subscribername: "",
      selectedSubscriberName: "",
      typing: false,
      typingTimeout: 0,
      selectedmedication: "",
      selectedSubscriber: "",
      selectedFile: [],
      selectedFileError: null,
      selectedFile2: [],
      selectedFile2Error: null,
      selectedReportFile: [],
      selectedReportFileError: null,
      processing: true,
      reportfile_url: [],
      prescription_url: [],
      generic_report_file: [],
      subscriber_detail: [],
      package_data: [],
      report_data: [],
      contentLoading: true,
      medicationloading: false,
      city_info: [],
      country_detail: [],
      medication_detail: [],
      addmedicationdetailform: [],
      subscriber: 0,
      newsubscriber: "",
      subscriberError: null,
      opharmareferance: "",
      mypharmareferance: "",
      mypharmareferanceError: null,
      opharmareferanceError: null,
      prescription: "",
      priscriptionurl: "",
      priscriptionurlError: null,
      orderdate: new Date(),
      paymentduedate: new Date(),
      source: "1",
      LabItems: [],
      reportmodal: false,
      noRecordFound: false,
      subscriberItems: [],
      healthconditionItems: [],
      healthconditiondetails: [],
      srno: 1,
      item_type: "1",
      description: "0",
      unitprice: "",
      quantity: "",
      subtotal: "",
      newmargin: "",
      discountamount: 0,
      basketvalue: "",
      deliverytype: "1",
      deliverycharge: 0,
      deliverychargeError: null,
      totalcost: "",
      totalcostError: null,
      lastsubscriptionorder: "",
      lastsubscriptionorderError: null,
      page: "",
      username: "",
      useremail: "",
      userphone: "",
      usermobile: "",
      addressradio: "",
      loading: false,
      name: "",
      nameError: null,
      mobileno: "",
      mobilenoError: null,
      status: "1",
      statusError: null,
      phoneno: "",
      phonenoError: null,
      email: "",
      emailError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "0",
      countryError: null,
      address_form_data: [],
      order_form_detail: [],
      m_id: [],
      companyname: "",
      discount: 0,
      companynote: "",
      _notificationSystem: null,
      cardHidden: true,
      medicationdataList: [],
      lastsubscription: [],
      showModal: false,
      showaddressModal: false,
      subscriptiondetail: [],
      sales_rep: "",
      sales_rep_data: [],
      medicationdata: [],
      quanitydata: [],
      addressdata: [],
      address_id: "",
      addressaccess: "0",
      inputList: [],
      uploadprescriptionlist: [],
      uploadreportlist: [],
      alert: null,
      medicationaddError: null,
      marginmodal: false,
      discountmodal: false,
      margintype: "1",
      discountpercentage: 0,
      marginpercentage: 0,
      marginamount: 0,
      b2borganizationdiscount: 0,
      showmediactonModal: false,
      labpackage: [],
      packageItems: [],
      package: [],
      packageError: null,
      description: "",
      descriptionError: null,
      price: "",
      priceError: null,
      unit_priceError: null,
      is_featured: "2",
      test_code: "",
      test_codeError: null,
      Dept_Name: "",
      Dept_NameError: null,
      Dept_details: [],
      Parent_Test: "",
      Parent_TestError: null,
      Short_Name: "",
      Display_Name: "",
      Method_Name: "",
      Specimen_Name: "",
      Container_Name: "",
      Min_Process_Time: null,
      Emergency_Process_Time: null,
      Reporting_Days: "",
      unit_price: "",
      reportname: "",
      reportnameError: null,
      category_detail: [],
      marginfinalamount: 0,
      displaymarginamount: "",
      displaymarginpercentage: "",
      dynamicfinalpercentage: 0,
      b2baccess: 0,
      city_id: "",
      errormessages: [],
      reporterrormessage: [],
      addnewaddress: false,
      healthcondition: null,
      paymentoption: null,
      paymentoptionError: null,
      currentMedicineIndex: "",
      ordernote: "",
      rider_id: null,
      rider_idError: null,
      rider_details: [],
      rider_data: [],
      purposoftesting: "",
      partialcondition: "",
      sampletype: "",
      placeofsamplecolletion: "",
      modeoftransportation: "",
      institute: "",
      nameofcollector: "",
      deliverydate: new Date(),
      deliverytimeslot: "",
      deliverytimeslotError: null,
      show_instruction1: null,
      show_instruction2: null,
      expressdeliverychargevalue: "",
      isLoading: false,
      catalougepackageId: null,
      catalougepackagename: null,
      catPackageDiscount: 0,
      catPackageDiscountAmount: 0,
      packagefeatures: [],
      sub_orderType: false,
      first_address: "",
      sourceValue: "",
      isClaimableOrder: false,
      cataloguePackageId: "",
      policyType: "2",
      ClaimPolicyDetails: "",
      claimCreditType: 0,
      avalable_flash_point: "",
      labPartnerName: "",
      latitude: "",
      longitude: "",
      isPackageHasClaimLabAllowed: false,
      tokenDetails: { token: JSON.parse(localStorage.getItem("user")) },
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handlebasketandsubtotal = this.handlebasketandsubtotal.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleb2bdetails = this.handleb2bdetails.bind(this);
    this.lastorderdetail = this.lastorderdetail.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileChange2 = this.handleFileChange2.bind(this);
    this.handleReportFileChange = this.handleReportFileChange.bind(this);
    this.opendiscountmodal = this.opendiscountmodal.bind(this);
    this.openmarginmodal = this.openmarginmodal.bind(this);
    this.reportChange = this.reportChange.bind(this);
    this.addrssselect = this.addrssselect.bind(this);
    this.report_error = React.createRef();
    this.message_error = React.createRef();
    this.inputOnChange = this.inputOnChange.bind(this);
    this.handleprescriptionupload = this.handleprescriptionupload.bind(this);
    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);
    this.setIndexValue = this.setIndexValue.bind(this);
    this.handledeliveryDate = this.handledeliveryDate.bind(this);
    this.handleshow_instruction1 = this.handleshow_instruction1.bind(this);
    this.handleshow_instruction2 = this.handleshow_instruction2.bind(this);
  }

  handleshow_instruction1(e) {
    var checked = e.target.checked;
    this.setState({ show_instruction1: checked });
  }

  handleshow_instruction2(e) {
    var checked = e.target.checked;
    this.setState({ show_instruction2: checked });
  }

  upload() {
    document.getElementById("selectImage").click();
  }

  upload2() {
    document.getElementById("selectImage2").click();
  }

  reportChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  addanother() {
    this.serial = 1;
    this.setState({
      addressaccess: "1",
      adressradio: "",
      addressline2: "",
      addressline1: "",
      city: "0",
      postalcode: "",
      country: "0",
      LabItems: [],
      medication_detail: [],
      cityError: null,
      countryError: null,
      addnewaddress: true,
    });
    this.setState({ medicationloading: false });

    this.setState({
      address_id: "0",
      addressline2: this.state.addressline2,
      addressline1: this.state.addressline1,
      city: this.state.city,
      postalcode: this.state.postalcode,
      country: this.state.country,
    });

    this.handlebasketandsubtotal();
  }

  handleDateChange = (date) => {
    this.setState({
      orderdate: date,
    });
  };

  handlePaymentDueDate = (date) => {
    this.setState({ paymentduedate: date });
  };

  handledeliveryDate = (date) => {
    this.setState({ deliverydate: date });
  };

  handleAddClick = () => {
    var serial = 1;
    this.setState({
      inputList: [
        ...this.state.inputList,
        {
          f_index: this.getfileindex(),
          srno: this.getSerial(),
          item_type: "1",
          description: "",
          unitprice: 0,
          newmargin: 0,
          margin_discount_percentage: "",
          margin_discount_sub_type: 2,
          selectedReportFile: [],
          quantity: 1,
          subtotal: 0,
          LabItems: [],
          selectmedication: "",
          claimableValue: 0,
          isChecked: false,
        },
      ],
    });
  };

  handleAddPrescription = () => {
    this.setState({
      uploadprescriptionlist: [
        ...this.state.uploadprescriptionlist,
        { selectedFile: "" },
      ],
    });
  };

  onhealthconditionchnage = (value) => {
    this.setState({
      healthcondition: value,
    });
  };

  onSubscriberChange = async (value) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      subscriber: value.value,
      inputList: [],
    });

    await this.handleb2bdetails();
    await this.handlebasketandsubtotal();
    await this.handlebasketandsubtotal();
    await getremaincreditforleaduser(value.value, obj).then((res) => {
      console.log(res.data.remainingCredit, "remian credit ");
      this.setState({ avalable_flash_point: res.data.remainingCredit });
    });
    await getAvailableCreditsByLeads(
      value.value,
      this.state.claimCreditType,
      obj
    ).then((res) => {
      console.log("availableTotalClaimCredits", res.data.remainingCredit);
      this.setState({ availableTotalClaimCredits: res.data.remainingCredit });
    });

    this.setState({
      deliverycharge: 0,
      totalcost: "",
      discountamount: 0,

      name: "",
      email: "",
      phoneno: "",
      mobileno: "",
      addressline1: "",
      addressline2: "",
      city: "0",
      country: "0",
      postalcode: "",
      lastsubscription: [],
    });

    // this.handlebasketandsubtotal();

    this.setState({ subscriberItems: [] });
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (name == "discountpercentage") {
      if (re.test(value) == true) {
        this.setState({
          [name]: value,
        });
      }
    } else {
      this.setState({
        [name]: value,
      });
    }

    if (name == "source") {
      if (value == "2") {
        this.setState({ mypharmareferance: "" });
      } else if (value == "3") {
        this.setState({ opharmareferance: "" });
      }
    }
    if (name == "deliverytype") {
      if (value == "2") {
        this.setState({
          deliverycharge: this.state.expressdeliverychargevalue,
        });
      } else {
        this.setState({ deliverycharge: 0 });
      }
    }
    if (name == "country") {
      if (value != 0) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var country_id = value;

        getCity(obj, country_id).then((res) => {
          // console.log(res,'city');
          this.setState({ city_info: res.data });
        });
      } else if (value == "0") {
        this.setState({ city_info: [] });
      }
    }

    if (name == "city") {
      if (value != "0") {
        this.addrssselect(0, value);
      }
    }

    if (name == "margintype") {
      this.setState({ marginfinalamount: 0 });
    }
    // if(this.state.marginpercentage == '')
    // {
    //   this.setState({ marginpercentage: 0 });
    // }

    // if(this.state.marginamount == '')
    // {
    //   this.setState({ marginamount :  0 });
    // }
    this.handlebasketandsubtotal();
    if (name == "subscriber") {
      this.handleb2bdetails();
      this.handlebasketandsubtotal();

      this.setState({
        deliverycharge: 0,
        totalcost: "",
        discountamount: 0,

        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "0",
        postalcode: "",
        lastsubscription: [],
      });
    }
    // this.handlebasketandsubtotal();
  };

  async lastorderdetail(id) {
    this.setState({ showModal: true, quanitydata: [], medicationdataList: [] });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await getLabOrdersbyid(id, obj).then((res) => {
      var data = res.data.orderItems;
      let medi_array = [];

      this.setState({
        medicationdataList: data,
      });
      this.setState({
        subscriptiondetail: res.data,
        quanitydata: data,
      });
    });
  }

  async lastorderdata(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let compelte = 1;
    let pg_no = 1;
    this.setState({ noRecordFound: false });
    while (compelte == 1) {
      this.setState({ noRecordFound: false });
      await searchLablastsubscription(id, pg_no, obj).then((res) => {
        var orderdata = res.data;

        console.log(res, "<<- res");
        if (orderdata.length == 0) {
          this.setState({ noRecordFound: true });
        }

        if (orderdata.length == 0) {
          compelte = 0;
        } else {
          compelte = 0;
          var array1 = this.state.lastsubscription;
          var array2 = array1.concat(orderdata);

          this.setState({
            lastsubscription: array2,
          });
        }
      });
      pg_no++;
    }
  }

  handleb2bdetails() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    // console.log( this.state.subscriber_detail,"subscriber detail")
    this.setState({ loading: true }, () => {
      this.state.subscriber_detail.map((detail) => {
        // console.log(detail.id,"==",this.state.subscriber)

        if (this.state.subscriber == detail.id) {
          if (
            detail.lead_catalogue_package != null &&
            detail.lead_catalogue_package != [] &&
            detail.lead_catalogue_package != ""
          ) {
            const leadCataloguePackageDetails =
              detail.lead_catalogue_package.find((data) => data);
            this.setState({
              cataloguePackageId: leadCataloguePackageDetails.package_id,
            });
            var packagediscount = 0;
            var features = [];
            var packagefeatues = {
              lab: "",
            };

            var lab = "";
            let claim = [];

            var fetlist =
              detail.lead_catalogue_package[0].lead_catalogue_package_feature;

            for (let i = 0; i < fetlist.length; i++) {
              if (fetlist[i].feature_title == "lab_discount") {
                var lab = fetlist[i];
              } else if (
                fetlist[i].feature_title == "claim" &&
                JSON.parse(fetlist[i].feature_value).length !== 0
              ) {
                claim = JSON.parse(fetlist[i].feature_value);
                const findCreditType = claim.find((item) => item);
                this.setState({
                  claimCreditType: findCreditType.creditType,
                  isPackageHasClaimLabAllowed: findCreditType.lab,
                });
              }
            }

            if (lab.feature_value != null && lab.is_active == 1) {
              packagefeatues.lab = lab.feature_value;
            }

            features.push(packagefeatues);

            if (lab.is_active == 1) {
              if (lab.feature_value != null) {
                packagediscount = parseInt(lab.feature_value);
              }
            }

            console.log(packagediscount);
            if (detail.lead_catalogue_package[0].catalogue_package != null) {
              var catpackage =
                detail.lead_catalogue_package[0].catalogue_package;
              var packagename = catpackage.title;
              var packageid = catpackage.id;

              this.setState({
                catalougepackageId: packageid,
                catalougepackagename: packagename,
                catPackageDiscount: packagediscount,
                packagefeatures: features,
              });
            }
          } else {
            this.setState({
              catalougepackageId: "",
              catalougepackagename: "",
              catPackageDiscount: 0,
              packagefeatures: [],
            });
          }

          if (detail.b2b == null) {
            this.setState({
              loading: false,
              companyname: "",
              // deliverycharge : 0,
              companynote: "",
              discount: 0,
              discountamount: 0,
              b2borganizationdiscount: 0,
              b2baccess: 0,
            });
            this.lastorderdata(detail.id);
            this.setState({
              loading: false,
              name: detail.name,

              email: detail.email,
              phoneno: detail.phone,
              mobileno: detail.mobile_no,
              addressdata: detail.address,
              username: detail.name,
              useremail: detail.email,
              userphone: detail.phone,
              usermobile: detail.mobile_no,
              b2bdeliverycharge: "",
            });

            // set default address detail load
            detail.address.map((add, indexk) => {
              if (indexk == 0) {
                this.setState({
                  first_address: add.id,
                });
                this.addrssselect(add.id, add.city);
              }
            });
          } else {
            this.setState({
              loading: false,
              name: detail.name,
              email: detail.email,
              phoneno: detail.phone,
              mobileno: detail.mobile_no,
              b2baccess: 1,

              companyname: detail.b2b["company_name"],
              deliverycharge: detail.b2b["delivery_value"],
              b2bdeliverycharge: detail.b2b["delivery_value"],
              companynote: detail.b2b["note"],
              discount: detail.b2b["discount"],
              username: detail.name,
              useremail: detail.email,
              userphone: detail.phone,
              usermobile: detail.mobile_no,
              addressdata: detail.address,
              b2borganizationdiscount: detail.b2b["discount"],
            });

            this.lastorderdata(detail.id);

            // set default address detail load
            detail.address.map((add, indexk) => {
              if (indexk == 0) {
                this.setState({
                  first_address: add.id,
                });
                this.addrssselect(add.id, add.city);
              }
            });
          }
        }
      });
    });
  }

  async getReport() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let compelte_repo = 1;
    let repo_pg_no = 1;
    while (compelte_repo == 1) {
      await GetReports(obj, repo_pg_no)
        .then((res) => {
          const data = res.data.data;
          if (data.length == 0) {
            compelte_repo = 0;
          } else {
            var array1 = this.state.report_data;
            var array2 = array1.concat(data);

            this.setState({
              report_data: array2,
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
      repo_pg_no++;
    }
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    this.claimableTotal = 0;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    this.getReport();
    let compelte_pac = 1;
    let pac_pg_no = 1;
    while (compelte_pac == 1) {
      await GetPackages(obj, pac_pg_no)
        .then((res) => {
          const data = res.data.data;

          if (data.length == 0) {
            compelte_pac = 0;
          } else {
            var array1 = this.state.package_data;
            var array2 = array1.concat(data);

            this.setState({
              package_data: array2,
            });

            let pcItems = [];
            this.state.package_data.map((x, i) => {
              pcItems.push({ value: x.id, label: x.package_name });
            });
            this.setState({
              packageItems: pcItems,
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
      pac_pg_no++;
    }

    if (this.props.match.params.id !== undefined) {
      let propvalue = this.props.match.params.id;
      console.log("propvalue", propvalue);

      await get_single_lead_data(propvalue, obj).then((lead_data) => {
        var leaddata = lead_data.data;
        this.setState({
          selectedSubscriberName: leaddata.data[0].name,
          subscriber_detail: leaddata.data,
        });
      });
      this.setState({ subscriber: propvalue });

      this.setState({ selectedSubscriber: propvalue });
      //this.sendToParent("jaimin")
      this.handlebasketandsubtotal();

      this.handleb2bdetails();
      this.handlebasketandsubtotal();
    }
    GetDepartment(obj)
      .then((res) => {
        this.setState({ Dept_details: res.data });
      })
      .catch((error) => {
        this.handleNetworkError("bl");
        console.log(error, "== error");
      });

    var settings_id = "2";
    Get_Settings_byid(settings_id, obj).then((res) => {
      console.log(res.data.data.setting_value, "settings");
      this.setState({
        expressdeliverychargevalue: res.data.data.setting_value,
      });
    });
    // generate subscriber option array
    //generate healthcondition option
    let compelte_hc = 1;
    let hc_pg_no = 1;
    while (compelte_hc == 1) {
      var country_id = "1";
      await getpagewiseHealthcondition(hc_pg_no, country_id, obj).then(
        (res) => {
          const data = res.data.data;
          if (data.length == 0) {
            compelte_hc = 0;
          } else {
            var array1 = this.state.healthconditiondetails;
            var array2 = array1.concat(data);

            this.setState({
              healthconditiondetails: array2,
            });

            let hcItems = [];
            this.state.healthconditiondetails.map((x, i) => {
              hcItems.push({
                value: x.healthconditionname,
                label: x.healthconditionname,
              });
            });
            this.setState({
              healthconditionItems: hcItems,
            });
          }
        }
      );
      hc_pg_no++;
    }

    let role = 7;
    getallrider(role, obj).then((res) => {
      const data = res.data;

      var array1 = this.state.rider_details;
      var array2 = array1.concat(data);

      this.setState({
        rider_details: array2,
      });

      let riderItems = [];
      this.state.rider_details.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        rider_data: riderItems,
      });
    });
    getAllLabPartners(obj).then((res) => {
      const data = res.data.data;
      const getAllLabPartner = data.map((partner) => {
        return {
          value: partner.id,
          label: partner.name,
        };
      });
      this.setState({ labPartnerOptions: getAllLabPartner });
    });

    await getAvailableCreditsByLeads(
      this.state.subscriber,
      this.state.claimCreditType,
      obj
    ).then((res) => {
      this.setState({ availableTotalClaimCredits: res.data.remainingCredit });
    });
    // get all sales representative

    getSalesRepresentative(obj).then((res) => {
      const data = res.data.data;

      var array1 = this.state.sales_rep_data;
      var array2 = array1.concat(data);

      this.setState({
        sales_details: array2,
      });

      let repItems = [];
      this.state.sales_details.map((x, i) => {
        repItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        sales_rep_data: repItems,
      });
    });
    var country_id = 1;

    getCity(obj, country_id).then((res) => {
      this.setState({ city_info: res.data });
    });

    // this.handlebasketandsubtotal();
    // this.handletotalcost(this.state.deliverycharge);
    await getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    if (this.props.match.params.id !== undefined) {
      let propvalue = this.props.match.params.id;

      await get_single_lead_data(propvalue, obj).then((lead_data) => {
        var leaddata = lead_data.data;
        this.setState({
          selectedSubscriberName: leaddata.data[0].name,
          subscriber_detail: leaddata.data,
        });
      });
      this.setState({ subscriber: propvalue });

      this.setState({ selectedSubscriber: propvalue });
      //this.sendToParent("jaimin")
      this.handlebasketandsubtotal();

      this.handleb2bdetails();
      this.handlebasketandsubtotal();
      this.setState({
        deliverycharge: 0,
        totalcost: "",
        discountamount: 0,

        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "0",
        postalcode: "",
        lastsubscription: [],
      });
    }
    this.setState({ contentLoading: false });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Lab Order</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.setState({ isLoading: false });
      this.props.history.push("/admin/lab_order_list");
    }, 3000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  serial = 1;
  getSerial() {
    return this.serial++;
  }
  fileindex = 0;
  getfileindex() {
    return this.fileindex++;
  }

  async onSendQuote() {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }
    if (this.state.selectedReportFile.length != 0) {
      error = false;
      this.state.selectedReportFile.map((rfile) => {
        if (rfile.length > 5) {
          error = true;
          this.setState({
            selectedReportFileError: (
              <small className="text-danger">
                Report Files must be less than 5 file.
              </small>
            ),
          });
        } else {
          this.setState({ selectedReportFileError: null });
        }
      });
    }
    if (this.state.selectedFile.length != 0) {
      error = false;
      this.state.selectedFile.map((file) => {
        if (file.length > 5) {
          error = true;
          this.setState({
            selectedFileError: (
              <small className="text-danger">
                Prescription Files must be less than 5 file.
              </small>
            ),
          });
        } else {
          this.setState({ selectedFileError: null });
        }
      });
    }

    if (this.state.totalcost.length == 0) {
      error = true;
      this.setState({
        totalcostError: (
          <small className="text-danger">Total Cost is required.</small>
        ),
      });
    } else {
      this.setState({ totalcostError: null });
    }

    if (this.state.inputList.length == 0) {
      error = true;

      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Report data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      error = false;
      this.state.inputList.map((x, i) => {
        // console.log(i,x.description,'check i x ')
        if (x.description == "") {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Report data!</h4>
              </SweetAlert>
            ),
          });
        } else {
          if (error == true) {
            this.setState({ medicationaddError: null });
          } else {
          }
        }
      });
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: <small className="text-danger">city is required.</small>,
        });
      } else {
        this.setState({ cityError: null });
      }
      if (this.state.latitude.length === 0) {
        error = true;
        this.setState({
          latiAndLogitError: (
            <small className="text-danger">
              Latitude and Longitude are required.
            </small>
          ),
        });
      } else {
        this.setState({ latiAndLogitError: null });
      }
    }
    if (this.state.rider_id == null) {
      /*error = true
           this.setState({
            rider_idError: (
                <small className="text-danger">
                  Rider is required.
                </small>
              )
            })*/
    } else {
      this.setState({ rider_idError: null });
    }
    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }
    if (this.state.addressline1.length === 0) {
      error = true;
      this.setState({
        addressline1Error: (
          <small className="text-danger">Address is required.</small>
        ),
      });
    } else {
      this.setState({ addressline1Error: null });
    }

    if (this.state.deliverytimeslot.length == 0) {
      error = true;
      this.setState({
        deliverytimeslotError: (
          <small className="text-danger">
            Collection Time slot is required.
          </small>
        ),
      });
    } else {
      this.setState({ deliverytimeslotError: null });
    }

    if (error) {
      this.message_error.current.focus();
    }

    if (!error) {
      this.setState({ isLoading: true });
      //if(1)
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let reportform = [];

      this.state.inputList.map((x, i) => {
        /* reportform.push({
          id: x.description,
          quantity: x.quantity,
          item_type: x.item_type,
          margin_discount_percentage: 0,
          report_file: x.selectedReportFile,
        }); */

        if (x.margin_discount_sub_type == 2) {
          reportform.push({
            id: x.description,
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_price: x.newmargin,
            margin_discount_percentage: 0,
            //item_id: x.orderItemNumber,
            report_file: x.selectedReportFile,
          });
        } else if (x.margin_discount_sub_type == 1) {
          reportform.push({
            id: x.description,
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_price: 0,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_percentage: x.margin_discount_percentage,
            //item_id: x.orderItemNumber,
            report_file: x.selectedReportFile,
          });
        }
      });

      const channel = "web";
      const created_by = token.id;
      const date = new Date(this.state.orderdate);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;

      const paymentdate = new Date(this.state.paymentduedate);
      var pdd = ("0" + paymentdate.getDate()).slice(-2);
      var pmm = ("0" + (paymentdate.getMonth() + 1)).slice(-2);
      var pyyyy = date.getFullYear();
      var ptoday = pyyyy + "-" + pmm + "-" + pdd;

      const deliverydate = new Date(this.state.deliverydate);
      var ddd = ("0" + deliverydate.getDate()).slice(-2);
      var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
      var dyyyy = date.getFullYear();
      var dtoday = dyyyy + "-" + dmm + "-" + ddd;

      if (this.state.selectedFile != null) {
        const data = new FormData();
        var index_data = 0;
        this.state.selectedFile.map((file) => {
          for (var i = 0; i < file.length; i++) {
            data.append("presription_file[]", file[i]);
          }
        });
        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/prescription";
        await axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({
              prescription_url: res.data.data.prescription_url,
            });
          });
      }

      var marginvalue = "";
      if (this.state.margintype == 1) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      } else if (this.state.margintype == 2) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      }
      var discountper = 0;
      if (this.state.dynamicfinalpercentage != 0) {
        discountper = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        if (this.state.discount == null) {
          discountper = 0;
        } else {
          discountper = parseFloat(this.state.discount);
        }
      }
      // }
      // else
      // {
      //   discountper = 0
      // }
      // console.log(this.state.status)

      var tag = [];
      if (this.state.healthcondition == null) {
        tag = "";
      } else {
        this.state.healthcondition.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.label);
          tag = array2;
        });
      }
      // console.log(this.state.paymentoption.value,'paymentoption',this.state.subscriber)
      var paymentop = "";
      if (this.state.paymentoption != null) {
        paymentop = this.state.paymentoption.value;
      }
      var rider_info = "";
      if (this.state.rider_id != null) {
        rider_info = this.state.rider_id.value;
      }
      var show_instruction1_data = "";
      if (this.state.show_instruction1 != null) {
        if (this.state.show_instruction1 == true) {
          show_instruction1_data = "1";
        } else if (this.state.show_instruction1 == false) {
          show_instruction1_data = "0";
        }
      }
      var show_instruction2_data = "";
      if (this.state.show_instruction2 != null) {
        if (this.state.show_instruction2 == true) {
          show_instruction2_data = "1";
        } else if (this.state.show_instruction2 == false) {
          show_instruction2_data = "0";
        }
      }

      var subOrderType = "1";
      if (this.state.sub_orderType == true) {
        subOrderType = "2";
      }

      this.setState({ processing: false }, () => {
        SendQuoteLabOrder(
          this.state.subscriber,
          this.state.source,
          this.state.opharmareferance,
          today,
          this.state.prescription,
          this.state.priscriptionurl,
          this.state.deliverytype,
          this.state.deliverycharge,
          this.state.lastsubscriptionorder,
          this.state.address_id,
          this.state.addressline1,
          this.state.addressline2,
          this.state.city,
          this.state.postalcode,
          this.state.country,
          channel,
          reportform,
          obj,
          this.state.basketvalue,
          this.state.totalcost,
          this.state.lastsubscriptionorder,
          this.state.email,
          this.state.name,
          this.state.mobileno,
          this.state.phoneno,
          this.state.status,
          this.state.prescription_url,
          this.state.margintype,
          marginvalue,
          discountper,
          tag,
          paymentop,
          ptoday,
          this.state.ordernote,
          this.state.mypharmareferance,
          rider_info,
          this.state.purposoftesting,
          this.state.institute,
          this.state.nameofcollector,
          this.state.partialcondition,
          this.state.sampletype,
          this.state.placeofsamplecolletion,
          this.state.modeoftransportation,
          dtoday,
          this.state.deliverytimeslot,
          show_instruction1_data,
          show_instruction2_data,
          subOrderType,
          this.state.latitude,
          this.state.longitude,
          this.state.source
        )
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
                this.setState({ isLoading: false });
              } else {
                this.handleClick("bl");
                this.setState({ isLoading: false });
              }
            } else if (res.data.success === true) {
              this.setState({ processing: true });
              this.handleSuccess("bl");
            }
            // this.props.history.push('/admin/order_list');
          })
          .catch((error) => {
            this.handleNetworkError("bl");
            this.setState({ isLoading: false });
          });
      });
    }
  }

  handleFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile: data });
  }

  handleFileChange2(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile2: data });
  }

  async handleReportFileChange(event, index) {
    let datareport = [];
    const { name, value } = event.target;
    datareport.push(event.target.files);
    const list = [...this.state.inputList];

    list[index][name] = datareport;
    this.setState({
      inputList: list,
    });

    const data = new FormData();
    this.state.inputList.map((x, i) => {
      x.selectedReportFile.map((file) => {
        for (var i = 0; i < file.length; i++) {
          data.append("report_file[]", file[i]);
        }
      });
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/report";
    await axios
      .post(url, data, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "Content-Type": "application/json",
          "X-Request-Id": "124",
        },
      })
      .then((res) => {
        this.setState({
          reportfile_url: res.data.data.report_url,
        });
        list[index]["selectedReportFile"] = this.state.reportfile_url;
        this.setState({ inputList: list });
      });
  }

  openreportmodal() {
    this.setState({ reportmodal: true });
  }

  closereportmodal() {
    this.setState({ reportmodal: false });
  }

  async submitreportmodal() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var error = false;

    const data = new FormData();
    this.state.inputList.map((x, i) => {
      x.selectedReportFile.map((file) => {
        for (var i = 0; i < file.length; i++) {
          data.append("report_file[]", file[i]);
        }
      });
    });

    let url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/report";
    await axios
      .post(url, data, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "Content-Type": "application/json",
          "X-Request-Id": "124",
        },
      })
      .then((res) => {
        this.setState({
          reportfile_url: res.data.data.report_url,
        });
        var list = this.state.inputList.map((x, i) => {
          x.selectedReportFile.push(res.data.data.report_url);
        });

        // this.setState({ inputList: list });
      });
    //  }
    // }
  }
  reportupload(opt) {
    document.getElementById(opt).click();
  }
  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }
    if (Number(this.state.address_id) === 0) {
      if (this.state.addressline1.length === 0) {
        error = true;
        this.setState({
          addressline1Error: (
            <small className="text-danger">address is required.</small>
          ),
        });
      } else {
        this.setState({
          addressline1Error: null,
        });
      }
    } else {
      this.setState({
        addressline1Error: null,
      });
    }

    if (this.state.selectedReportFile.length != 0) {
      error = false;
      this.state.selectedReportFile.map((rfile) => {
        if (rfile.length > 5) {
          error = true;
          this.setState({
            selectedReportFileError: (
              <small className="text-danger">
                Report Files must be less than 5 file.
              </small>
            ),
          });
        } else {
          this.setState({ selectedReportFileError: null });
        }
      });
    }
    if (this.state.selectedFile.length != 0) {
      error = false;
      this.state.selectedFile.map((file) => {
        if (file.length > 5) {
          error = true;
          this.setState({
            selectedFileError: (
              <small className="text-danger">
                Prescription Files must be less than 5 file.
              </small>
            ),
          });
        } else {
          this.setState({ selectedFileError: null });
        }
      });
    }

    if (this.state.totalcost.length == 0) {
      error = true;
      this.setState({
        totalcostError: (
          <small className="text-danger">Total Cost is required.</small>
        ),
      });
    } else {
      this.setState({ totalcostError: null });
    }

    if (this.state.inputList.length == 0) {
      error = true;

      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Report data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      error = false;
      this.state.inputList.map((x, i) => {
        // console.log(i,x.description,'check i x ')
        if (x.description == "") {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Report data!</h4>
              </SweetAlert>
            ),
          });
        } else {
          if (error == true) {
            this.setState({ medicationaddError: null });
          } else {
          }
        }
      });
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: <small className="text-danger">city is required.</small>,
        });
      } else {
        this.setState({ cityError: null });
      }
      if (
        this.state.latitude.length === 0 ||
        this.state.longitude.length === 0
      ) {
        error = true;
        this.setState({
          latiAndLogitError: (
            <small className="text-danger">
              Latitude and Longitude are required.
            </small>
          ),
        });
      } else {
        this.setState({ latiAndLogitError: null });
      }
    }

    if (this.state.rider_id == null) {
      /*error = true
             this.setState({
              rider_idError: (
                  <small className="text-danger">
                    Rider is required.
                  </small>
                )
              }) */
    } else {
      this.setState({ rider_idError: null });
    }

    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }

    if (this.state.deliverytimeslot.length == 0) {
      error = true;
      this.setState({
        deliverytimeslotError: (
          <small className="text-danger">
            Collection Time slot is required.
          </small>
        ),
      });
    } else {
      this.setState({ deliverytimeslotError: null });
    }

    if (error) {
      this.message_error.current.focus();
    }

    if (!error) {
      this.setState({ isLoading: true });
      //if(1)
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let reportform = [];

      this.state.inputList.map((x, i) => {
        /* reportform.push({
          id: x.description,
          quantity: x.quantity,
          item_type: x.item_type,
          margin_discount_percentage: 0,
          report_file: x.selectedReportFile,
        }); */
        if (x.margin_discount_sub_type == 2) {
          reportform.push({
            id: x.description,
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_price: x.newmargin,
            margin_discount_percentage: 0,
            report_file: x.selectedReportFile,
            claimable: x.isChecked,
          });
        } else if (x.margin_discount_sub_type == 1) {
          reportform.push({
            id: x.description,
            quantity: x.quantity,
            item_type: x.item_type,
            margin_discount_price: 0,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_percentage: x.margin_discount_percentage,
            report_file: x.selectedReportFile,
            claimable: x.isChecked,
          });
        }
      });

      const channel = "web";
      const created_by = token.id;
      const date = new Date(this.state.orderdate);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;

      const paymentdate = new Date(this.state.paymentduedate);
      var pdd = ("0" + paymentdate.getDate()).slice(-2);
      var pmm = ("0" + (paymentdate.getMonth() + 1)).slice(-2);
      var pyyyy = date.getFullYear();
      var ptoday = pyyyy + "-" + pmm + "-" + pdd;

      const deliverydate = new Date(this.state.deliverydate);
      var ddd = ("0" + deliverydate.getDate()).slice(-2);
      var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
      var dyyyy = date.getFullYear();
      var dtoday = dyyyy + "-" + dmm + "-" + ddd;

      if (this.state.selectedFile != null) {
        const data = new FormData();
        var index_data = 0;
        this.state.selectedFile.map((file) => {
          for (var i = 0; i < file.length; i++) {
            data.append("presription_file[]", file[i]);
          }
        });
        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/prescription";
        await axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({
              prescription_url: res.data.data.prescription_url,
            });
          });
      }

      // generic report upload
      if (this.state.selectedFile2 != null) {
        const data = new FormData();
        var index_data = 0;
        this.state.selectedFile2.map((file) => {
          for (var i = 0; i < file.length; i++) {
            data.append("report_file[]", file[i]);
          }
        });
        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/laborders/report";
        await axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({
              generic_report_file: res.data.data.report_url,
            });
          });
      }

      var marginvalue = "";
      if (this.state.margintype == 1) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      } else if (this.state.margintype == 2) {
        if (this.state.marginfinalamount != null) {
          marginvalue = parseFloat(this.state.marginfinalamount);
        } else {
          marginvalue = 0;
        }
      }
      var discountper = 0;
      if (this.state.dynamicfinalpercentage != 0) {
        discountper = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        if (this.state.discount == null) {
          discountper = 0;
        } else {
          discountper = parseFloat(this.state.discount);
        }
      }
      // }
      // else
      // {
      //   discountper = 0
      // }
      // console.log(this.state.status)

      var tag = [];
      if (this.state.healthcondition == null) {
        tag = "";
      } else {
        this.state.healthcondition.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.label);
          tag = array2;
        });
      }
      // console.log(this.state.paymentoption.value,'paymentoption',this.state.subscriber)
      var paymentop = "";
      if (this.state.paymentoption != null) {
        paymentop = this.state.paymentoption.value;
      }
      var rider_info = "";
      if (this.state.rider_id != null) {
        rider_info = this.state.rider_id.value;
      }

      var show_instruction1_data = "";
      if (this.state.show_instruction1 != null) {
        if (this.state.show_instruction1 == true) {
          show_instruction1_data = "1";
        } else if (this.state.show_instruction1 == false) {
          show_instruction1_data = "0";
        }
      }

      var show_instruction2_data = "";
      if (this.state.show_instruction2 != null) {
        if (this.state.show_instruction2 == true) {
          show_instruction2_data = "1";
        } else if (this.state.show_instruction2 == false) {
          show_instruction2_data = "0";
        }
      }
      var sales_user_id = this.state.sales_rep;

      var subOrderType = "1";
      if (this.state.sub_orderType == true) {
        subOrderType = "2";
      }

      this.setState({ processing: false }, () => {
        AddLabOrder(
          this.state.subscriber,
          this.state.source,
          this.state.opharmareferance,
          today,
          this.state.prescription,
          this.state.priscriptionurl,
          this.state.deliverytype,
          this.state.deliverycharge,
          this.state.lastsubscriptionorder,
          this.state.address_id,
          this.state.addressline1,
          this.state.addressline2,
          this.state.city,
          this.state.postalcode,
          this.state.country,
          channel,
          reportform,
          obj,
          this.state.basketvalue,
          this.state.totalcost,
          this.state.lastsubscriptionorder,
          this.state.email,
          this.state.name,
          this.state.mobileno,
          this.state.phoneno,
          this.state.status,
          this.state.prescription_url,
          this.state.margintype,
          marginvalue,
          discountper,
          tag,
          paymentop,
          ptoday,
          this.state.ordernote,
          this.state.mypharmareferance,
          rider_info,
          this.state.purposoftesting,
          this.state.institute,
          this.state.nameofcollector,
          this.state.partialcondition,
          this.state.sampletype,
          this.state.placeofsamplecolletion,
          this.state.modeoftransportation,
          dtoday,
          this.state.deliverytimeslot,
          show_instruction1_data,
          show_instruction2_data,
          this.state.generic_report_file,
          sales_user_id,
          subOrderType,
          this.state.isClaimableOrder ? "1" : "0",
          !!this.state.labPartnerName ? this.state.labPartnerName.label : "",
          this.state.latitude,
          this.state.longitude
        )
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
                this.setState({ isLoading: false });
              } else {
                this.handleClick("bl");
                this.setState({ isLoading: false });
              }
            } else if (res.data.success === true) {
              this.setState({ processing: true });
              this.handleSuccess("bl");
            }
            // this.props.history.push('/admin/order_list');
          })
          .catch((error) => {
            this.handleNetworkError("bl");
            this.setState({ isLoading: false });
          });
      });
    }
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  Add_New_Report() {
    this.setState({
      showmediactonModal: true,
      packageError: null,
      description: "",
      descriptionError: null,
      price: "",
      priceError: null,
      unit_priceError: null,
      test_code: "",
      test_codeError: null,
      Dept_Name: "",
      Dept_NameError: null,
      Parent_Test: "",
      Parent_TestError: null,
      Short_Name: "",
      Display_Name: "",
      Method_Name: "",
      Specimen_Name: "",
      Container_Name: "",
      Min_Process_Time: null,
      Emergency_Process_Time: null,
      Reporting_Days: "",
      unit_price: "",
      reportname: "",
      reportnameError: null,
    });
  }
  async add_new_report_data() {
    let error = false;
    if (this.state.reportname.length == 0) {
      error = true;
      this.setState({
        reportnameError: (
          <small className="text-danger">Report Name is required.</small>
        ),
      });
    } else {
      this.setState({ reportnameError: null });
    }
    // if(this.state.package.length == 0 )
    //   {error = true
    //     this.setState({
    //      packageError: (
    //          <small className="text-danger">
    //            Package is required.
    //          </small>
    //        )
    //      })
    //    }else{ this.setState({ packageError: null });}
    if (this.state.unit_price.length == 0) {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
    if (this.state.price.length == 0) {
      error = true;
      this.setState({
        priceError: <small className="text-danger">Price is required.</small>,
      });
    } else {
      this.setState({ priceError: null });
    }

    if (this.state.Dept_Name == 0) {
      error = true;
      this.setState({
        Dept_NameError: (
          <small className="text-danger">Department Name is required.</small>
        ),
      });
    } else {
      this.setState({ Dept_NameError: null });
    }

    // if(this.state.Parent_Test.length == 0)
    // {error = true
    //    this.setState({
    //     Parent_TestError: (
    //         <small className="text-danger">
    //           Parehnt Test is required.
    //         </small>
    //       )
    //     })
    //   }else{ this.setState({ Parent_TestErrorError: null });}
    if (this.state.test_code.length == 0) {
      error = true;
      this.setState({
        test_codeError: (
          <small className="text-danger">Test Code is required.</small>
        ),
      });
    } else {
      this.setState({ test_codeError: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      var package_d = [];
      if (this.state.package == null) {
        package_d = "";
      } else {
        this.state.package.map((data) => {
          var array1 = package_d;
          var array2 = array1.concat(data.value);
          package_d = array2;
        });
      }
      AddReport(
        this.state.reportname,
        package_d,
        this.state.test_code,
        this.state.unit_price,
        this.state.price,
        this.state.description,
        is_featured,
        this.state.Dept_Name,
        this.state.Parent_Test,
        this.state.Short_Name,
        this.state.Display_Name,
        this.state.Method_Name,
        this.state.Specimen_Name,
        this.state.Container_Name,
        this.state.Min_Process_Time,
        this.state.Emergency_Process_Time,
        this.state.Reporting_Days,
        obj
      )
        .then((res) => {
          this.setState({ report_data: [] });
          if (res.data.success === false) {
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({
                reporterrormessage: ermessage,
                showmediactonModal: true,
              });
              this.report_error.current.focus();
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success == true) {
            this.getReport();

            this.setState({
              showmediactonModal: false,
              description: "",
              price: "",
              test_code: "",
              package: [],
              Dept_Name: "",
              Parent_Test: "",
              is_featured: "2",
              Short_Name: "",
              Display_Name: "",
              Method_Name: "",
              Specimen_Name: "",
              Container_Name: "",
              Min_Process_Time: null,
              Emergency_Process_Time: null,
              Reporting_Days: "",
              unit_price: "",
              reportname: "",
            });

            // if(list['item_type'] == "2")
            // {
            // var medicationItems = [];
            // if(nrdata != undefined)
            // {
            //   var data = {value: nmdata.id, label : nmdata.title + '(' +nmdata.item_code+ ')'}

            //   var array1 = this.state.medicationItems;
            //   var array2 = array1.concat( data)

            //   var array1md = this.state.medication_detail;
            //   var array2md = array1md.concat( res.data.data)
            //  /* this.setState({  medication_detail : array2md,
            //     medicationItems : array2,  });*/
            // }
          } else {
            // this.setState({medication_detail :  this.state.medication_detail ,
            //  medicationItems : this.state.medicationItems});
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  }

  handleSelectChange = (index, value) => {
    let name = "description";
    const list = [...this.state.inputList];
    list[index][name] = value.value;
    var temp_arr = [];

    list[index]["LabItems"] = temp_arr;
    list[index]["selectmedication"] = value;

    if (list[index]["item_type"] == "1") {
      this.state.package_data.map((pac) => {
        if (list[index]["description"] == pac.id) {
          list[index]["unitprice"] = pac.price;
        }
      });
    } else if (list[index]["item_type"] == "2") {
      this.state.report_data.map((repo) => {
        if (list[index]["description"] == repo.id) {
          list[index]["unitprice"] = repo.price;
        }
      });
    }

    var actQua = list[index]["quantity"] ? list[index]["quantity"] : 0;
    list[index]["subtotal"] = parseFloat(list[index]["unitprice"]) * actQua;
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.setState({ inputList: list, totalcost: "", discountamount: 0 });

    // this.handleb2bdetails()
    // this.handletotalcost(this.state.deliverycharge);
    // console.log(this.state.inputList);
    var new_array = this.state.LabItems;
    new_array[index] = [];
    this.setState({ LabItems: new_array });
    this.handlebasketandsubtotal();
  };

  handleprescriptionupload = (e, index) => {
    const { name, value } = e.target;

    const list = [...this.state.uploadprescriptionlist];
    list[index][name] = e.target.files[index];

    this.setState({ uploadprescriptionlist: list });
  };
  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];
    list[index][name] = value;

    if (list[index]["unitprice"]) {
      var subtotal = list[index]["unitprice"] * list[index]["quantity"];
      var addmargin = 0;
      if (list[index]["margin_discount_sub_type"] == 2) {
        if (
          list[index]["newmargin"] != "" &&
          list[index]["newmargin"] != 0 &&
          list[index]["newmargin"] != null &&
          !isNaN(parseFloat(list[index]["newmargin"]))
        ) {
          addmargin = list[index]["newmargin"];
        } else {
          addmargin = 0;
        }
      } else {
        if (
          list[index]["margin_discount_percentage"] != "" &&
          list[index]["margin_discount_percentage"] != 0 &&
          list[index]["margin_discount_percentage"] != null &&
          !isNaN(parseFloat(list[index]["margin_discount_percentage"]))
        ) {
          addmargin =
            (subtotal * list[index]["margin_discount_percentage"]) / 100;
        } else {
          addmargin = 0;
        }
      }

      var actQua = list[index]["quantity"] ? list[index]["quantity"] : 0;
      list[index]["subtotal"] =
        (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) * actQua;
      list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

      list[index]["claimableValue"] = JSON.parse(list[index]["subtotal"]);
      let totalAmount =
        JSON.parse(this.handleClaimedValueOnChange()) +
        Number(this.state.deliverycharge);

      if (
        list[index]["isChecked"] &&
        totalAmount > this.state.availableTotalClaimCredits
      ) {
        list[index]["isChecked"] = false;
      }

      this.handlebasketandsubtotal();
    }

    this.setState({
      inputList: list,
    });
  };

  openmarginmodal() {
    this.setState({ marginmodal: true });
  }
  opendiscountmodal() {
    this.setState({ discountmodal: true });
  }

  closedynamicdiscount() {
    var dd = "";
    if (
      this.state.discountpercentage == 0 ||
      this.state.discountpercentage == null
    ) {
      this.setState({ discountpercentage: 0 });
    } else {
      this.setState({ discountpercentage: this.state.discountpercentage });
    }
    this.setState({
      discountmodal: false,
      // dynamicfinalpercentage : 0
    });
  }
  closedynamicmargin() {
    var margin = "";
    if (this.state.margintype == 1) {
      if (
        this.state.marginpercentage == null ||
        this.state.marginpercentage == 0
      ) {
        this.setState({ marginpercentage: 0 });
      } else {
        this.setState({ marginpercentage: this.state.marginpercentage });
      }
    } else if (this.state.margintype == 2) {
      if (this.state.marginamount == null || this.state.marginamount == 0) {
        this.setState({ marginamount: 0 });
      } else {
        this.setState({ marginamount: this.state.marginamount });
      }
    }

    this.setState({
      marginmodal: false,
      // marginfinalamount : margin
    });
  }

  submitdynamicdiscount() {
    this.handlebasketandsubtotal();
    var dd = "";
    if (
      this.state.discountpercentage != null ||
      this.state.discountpercentage != 0
    ) {
      dd = this.state.discountpercentage;
    } else {
      dd = 0;
    }
    this.setState({
      discountmodal: false,
      dynamicfinalpercentage: dd,
    });
  }
  submitdynamicmargin() {
    this.handlebasketandsubtotal();

    var margin = "";
    if (this.state.margintype == 1) {
      margin = 0;
      if (
        this.state.marginpercentage != null ||
        this.state.marginpercentage != 0
      ) {
        margin = this.state.marginpercentage;
      } else {
        margin = 0;
      }
      this.setState({ displaymarginpercentage: margin });
    } else if (this.state.margintype == 2) {
      margin = 0;
      if (this.state.marginamount != null || this.state.marginamount != 0) {
        margin = this.state.marginamount;
      } else {
        margin = 0;
      }
      this.setState({ displaymarginamount: margin });
    }

    this.setState({
      marginmodal: false,
      marginfinalamount: margin,
    });
  }
  handleRemoveFileclick = (index) => {
    const list = [...this.state.uploadprescriptionlist];
    list.splice(index, 1);
    this.setState({ uploadprescriptionlist: list });
  };
  // handle click event of the Remove button
  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });

    const list1 = list;

    let count_x = 1;
    let count_y = 0;
    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      list[ind]["f_index"] = count_y;
      count_x++;
      count_y++;
    });
    this.serial = count_x;
    this.fileindex = count_y;

    this.setState({ inputList: list1 });

    this.handlebasketandsubtotal();
  };

  handlebasketandsubtotal() {
    var data = 0;
    var basketamount = 0;

    this.setState({ loading: true }, () => {
      this.state.inputList.map((bas) => {
        var subtot = bas.subtotal ? parseFloat(bas.subtotal) : parseFloat(0);
        data = parseFloat(data) + subtot;
      });
      basketamount = parseFloat(data);

      if (this.state.margintype == 1) {
        var discountper = 0;
        if (this.state.marginfinalamount) {
          discountper = this.state.marginfinalamount;
        } else {
          discountper = 0;
        }

        var calculateamount =
          (parseFloat(data) * parseFloat(discountper)) / 100;
        data = parseFloat(data) + parseFloat(calculateamount);
      } else if (this.state.margintype == 2) {
        var marginamount = 0;
        if (this.state.marginfinalamount) {
          marginamount = this.state.marginfinalamount;
        } else {
          marginamount = 0;
        }
        data = parseFloat(data) + parseFloat(marginamount);
      }

      var discount = 0;
      var discount_amount = 0;

      if (this.state.dynamicfinalpercentage != 0) {
        discount = parseFloat(this.state.dynamicfinalpercentage);
        discount_amount = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        if (this.state.discount == null) {
          discount = 0;
        } else {
          discount = parseFloat(this.state.discount);
        }

        if (discount != 0 || discount != "NaN") {
          discount_amount =
            (parseFloat(basketamount) * parseFloat(discount)) / 100;
        } else {
          discount_amount = 0;
        }
      }

      var package_discount = 0;
      var package_discount_amount = 0;

      if (this.state.sub_orderType == true) {
      } else {
        package_discount = parseFloat(this.state.catPackageDiscount);
        if (
          !this.state.isClaimableOrder &&
          (package_discount != 0 || package_discount != "NaN")
        ) {
          package_discount_amount =
            (parseFloat(basketamount) * parseFloat(package_discount)) / 100;
        } else {
          package_discount_amount = 0;
        }
      }

      var deliverycharge = 0;

      if (this.state.deliverycharge) {
        deliverycharge = parseInt(this.state.deliverycharge);
      } else {
        deliverycharge = 0;
      }

      var amount = parseFloat(data) + parseFloat(deliverycharge);

      var totalvalue =
        parseFloat(amount) -
        parseFloat(discount_amount) -
        parseFloat(package_discount_amount);
      data = data.toFixed(2);
      totalvalue = totalvalue.toFixed(2);
      discount_amount = discount_amount.toFixed(2);

      this.setState({
        loading: false,
        basketvalue: data,
        totalcost: totalvalue,
        discountamount: discount_amount,
        catPackageDiscountAmount: package_discount_amount,
      });
    });
  }

  async addrssselect(id, city_id) {
    // this.setState({inputList :  []}) //empty exitsing medictaion list
    this.serial = 1;
    this.setState({
      address_id: id,
      city_id: city_id,
      // addressaccess : '0',
      cityError: null,
      countryError: null,
      LabItems: [],
      medication_detail: [],
      //addnewaddress :false
    });
    if (id != "" && id != 0) {
      this.setState({ addnewaddress: false, addressaccess: "0" });
    } else {
      this.setState({ addnewaddress: true, addressaccess: "1" });
    }
    this.handlebasketandsubtotal();
    let compelte = 1;
    let pg_no = 1;

    {
      /* 
   while(compelte==1)
   {
    var token = JSON.parse(localStorage.getItem('user'));
    // console.log(token.token);  
    const  obj = token.token;
    
    await getcitywiseMedication(obj,city_id,pg_no)
    .then(res=> {
      var mdata = res.data.data
      
      var medicationItems = []
      if(mdata.length == 0)
      {
           compelte = 0
            this.setState({medicationloading : false})
          //  this.setState({ medicationItems : medicationItems });
      }
      else
      {
        compelte = 1
        this.setState({medicationloading : true})
        

        var array1 = this.state.medication_detail;
                var array2 = array1.concat( mdata)
                 
                  this.setState({
                    medication_detail : array2
                  })
                  let medicationItems = []
                  //console.log(this.state.medication_detail,"medicationdetail");
                  this.state.medication_detail.map((x, i) => {
                    medicationItems.push({ value:x.id , label: x.title + '('+x.item_code+')' })
                  })
                 
                  //  console.log(medicationItems , "medication item");
                  this.setState({
                    medicationItems : medicationItems
                  })
      
      
      }
    
  })
  pg_no++
  // this.setState({medicationloading : true})

  }
  */
    }
  }
  //   handleFileChange(event) {
  //     this.setState({
  //          selectedFile: event.target.files[0],
  //        })
  //  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  sendToParentSubscriber = async () => {
    //this.props.searching(this.state.name);c
    // alert("==="+this.state.name.trim()+"===")
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
          });
        });

        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
    }
  };
  sendToParent = async (name, i) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      var token = JSON.parse(localStorage.getItem("user"));

      const list = [...this.state.inputList];

      let Lab_Items = [];

      //alert("in else")
      this.setState({ medication_detail: [] });
      if (list[i]["item_type"] == "1") {
        this.state.package_data.map((x, i) => {
          Lab_Items.push({
            value: x.id,
            label: x.package_name + "(" + x.package_code + ")",
          });
        });
        list[i]["LabItems"] = Lab_Items;
      } else if (list[i]["item_type"] == "2") {
        this.state.report_data.map((x, i) => {
          Lab_Items.push({
            value: x.id,
            label: x.title + "(" + x.test_code + ")",
          });
        });
        list[i]["LabItems"] = Lab_Items;
      }
      this.setState({ inputList: list });

      var mew_arr = [];
      mew_arr[i] = Lab_Items;

      this.setState({
        LabItems: mew_arr,
      });
    } else {
      // alert("==="+this.state.name.length+"===")
      const list = [...this.state.inputList];
      list[i]["LabItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], LabItems: [] });
    }
  };
  setIndexValue = (event, i) => {
    //this.setState({currentMedicineIndex :i})
    //console.log("index",i)
  };
  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim(), i);
      }, 500),
    });
  };
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  downshiftOnSubscriberChange = (selectedItem) => {
    var d = selectedItem.id;

    this.setState({ selectedSubscriber: d });
    this.setState({
      subscriber: d,
    });

    this.handlebasketandsubtotal();

    this.handleb2bdetails();
    this.handlebasketandsubtotal();

    this.setState({
      deliverycharge: "",
      totalcost: "",
      discountamount: 0,
      name: "",
      email: "",
      phoneno: "",
      mobileno: "",
      addressline1: "",
      addressline2: "",
      city: "0",
      country: "0",
      postalcode: "",
      lastsubscription: [],
    });
  };
  downshiftOnChange = (selectedItem, i) => {
    var index = i;

    var d = selectedItem.id;

    this.setState({ selectedmedication: d });

    let name = "description";
    const list = [...this.state.inputList];
    list[index][name] = selectedItem.id;
    list[index]["unitprice"] = selectedItem.price;

    list[index]["subtotal"] =
      list[index]["unitprice"] * list[index]["quantity"];
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.setState({ inputList: list, totalcost: "", discountamount: 0 });
    this.handlebasketandsubtotal();
    //alert(`your  Selected Medication  ${selectedItem.id}`)
  };

  handleSourceValue = (value) => {
    if (value.value == "2") {
      this.setState({ mypharmareferance: "" });
    } else if (value.value == "3") {
      this.setState({ opharmareferance: "" });
    } else {
      this.setState({ opharmareferance: "", mypharmareferance: "" });
    }
    this.setState({ sourceValue: value, source: value.value });
  };

  handleMarkedAsClaimOrderOnChange = (e) => {
    if (!e.target.checked) {
      const removeClaimableFlag = this.state.inputList.map((item) => {
        return {
          ...item,
          isChecked: false,
        };
      });
      this.setState({ inputList: removeClaimableFlag });
    }
    this.setState({ isClaimableOrder: e.target.checked });
    this.handlebasketandsubtotal();
  };

  showPolicyDetails() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getPolicyDetailsByPackgeId(
      obj,
      this.state.cataloguePackageId,
      this.state.policyType
    ).then((res) => {
      const claimPolicyDetails = res.data.find((data) => data);
      if (!!claimPolicyDetails) {
        this.setState({ ClaimPolicyDetails: claimPolicyDetails.policy });
      }
    });
  }
  handleClaimedValueOnChange() {
    let claimabaleTotalValue = 0;
    this.state.inputList.map((item) => {
      if (item.isChecked) {
        claimabaleTotalValue = claimabaleTotalValue + item.claimableValue;
      }
    });
    this.claimableTotal = claimabaleTotalValue;
    return claimabaleTotalValue.toFixed(2);
  }

  handleClaimableCheckBoxOnClick = (labOrderId, checked) => {
    // let  = event.target.checked
    if (checked) {
      let itemSubTotal = 0;
      const updatedArray = this.state.inputList.map((data) => {
        if (data.description === labOrderId) {
          if (
            Number(this.state.availableTotalClaimCredits) >
            Number(this.claimableTotal) +
              Number(data.subtotal) +
              Number(this.state.deliverycharge)
          ) {
            data.isChecked = checked;
            data.claimableValue = JSON.parse(data.subtotal);
            itemSubTotal = JSON.parse(data.subtotal);
            this.claimableTotal = this.claimableTotal + itemSubTotal;
            return {
              ...data,
              isChecked: checked,
              claimableValue: JSON.parse(data.subtotal),
            };
          } else {
            this.setState({
              alert: (
                <SweetAlert
                  className="order_alert"
                  style={{ display: "block", marginTop: "-100px" }}
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                >
                  <h4>Sorry! You can't make as claimable report </h4>
                </SweetAlert>
              ),
            });
          }
        }
        return data;
      });
      this.setState({ inputList: updatedArray });
      // this.claimableTotal = this.claimableTotal + itemSubTotal;
    } else {
      this.setState({ isAllChecked: false });
      const updatedArray = this.state.inputList.map((data) => {
        if (data.description === labOrderId) {
          data.isChecked = false;
          data.claimableValue = 0;
          return {
            ...data,
            isChecked: checked,
            claimableValue: 0,
          };
        }
        return data;
      });
      this.setState({ inputList: updatedArray });
    }
  };
  onLaborderPartnerOnchange = (value) => {
    this.setState({
      labPartnerName: value,
    });
  };
  handleInputLocationChange = (e) => {
    const input = e.target.value;
    this.setState({ input });
    const [latitude, longitude] = input.split(",").map((coord) => coord.trim());
    if (input.includes(",")) {
      this.setState({
        latitude: latitude || "",
        longitude: longitude || "",
      });
    } else {
      this.setState({
        latitude: latitude,
        longitude: "",
      });
    }
    this.setState({
      latiAndLogitError: null,
    });
  };

  render() {
    const subscriber_detail = this.state.subscriber_detail;
    const country_detail = this.state.country_detail;
    const view = <Tooltip id="view">View</Tooltip>;
    const subscriptiondetail = this.state.subscriptiondetail;
    const medicationdata = this.state.medicationdata;
    const quanitydata = this.state.quanitydata;
    const sub_id = this.state.subscriber;
    const hc_id = this.state.healthcondition;
    const errormessages = this.state.errormessages;
    const reporterrormessage = this.state.reporterrormessage;
    const isSuperAdmin = this.state.tokenDetails.token.role === 1;

    // console.log("sub id "+ sub_id + "subscriber_id"+this.state.subscriber);
    return (
      <div className="main-content">
        <Row style={{ margin: "0 4px" }}>
          {this.state.packagefeatures.length > 0 && (
            <div className="package_feature_static">
              <div className="package_featurelist">
                <h4>Package Discount Eligibility</h4>
              </div>
              {this.state.packagefeatures[0].lab != "" && (
                <div className="package_featurelist">
                  <h5>Lab:</h5>
                  <p>{this.state.packagefeatures[0].lab}%</p>
                </div>
              )}
              {this.state.catalougepackagename && (
                <div className="package_featurelist">
                  <h5>Package Name:</h5>
                  <p>{this.state.catalougepackagename}</p>
                </div>
              )}
            </div>
          )}
        </Row>

        <input
          style={{
            width: "0px",
            height: "0px",
            border: "none",
            display: "block",
          }}
          type="text"
          ref={this.message_error}
        />

        {this.state.contentLoading ? <LoadingOrder /> : ""}
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            content={
              <>
                <Row>
                  <Col sm={8} className="orderFormdata-container">
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <div
                      className="order_topdata_container"
                      style={{
                        marginBottom: "40px",
                        padding: "0 20px",
                      }}
                    >
                      <Row>
                        <Col md={12}>
                          <h3
                            style={{
                              margin: "0",
                              letterSpacing: "0.5px",
                              fontSize: "24px",
                            }}
                          >
                            Order Details
                          </h3>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <br></br>
                            <ControlLabel style={{ display: "block" }}>
                              Order Type
                            </ControlLabel>
                            <div
                              className="OrderType_switch"
                              style={{ marginTop: 16, marginBottom: 16 }}
                            >
                              <Switch
                                checked={this.state.sub_orderType}
                                onChange={(e) => {
                                  this.setState({
                                    sub_orderType: !this.state.sub_orderType,
                                  });
                                  if (this.state.subscriber != 0) {
                                    setTimeout(
                                      this.handlebasketandsubtotal,
                                      500
                                    );
                                  }
                                }}
                                onColor="#6c757d"
                                offColor="#007bff"
                                onHandleColor="#007bff"
                                offHandleColor="#6c757d"
                                height={32}
                                width={70}
                                uncheckedIcon={
                                  <div
                                    style={{
                                      padding: "7px 6px",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                  >
                                    B2C
                                  </div>
                                }
                                checkedIcon={
                                  <div
                                    style={{
                                      padding: "7px 10px",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                  >
                                    B2B
                                  </div>
                                }
                                className="react-switch"
                                id="small-radius-switch"
                              />
                            </div>
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Subscriber</ControlLabel>
                            {this.props.match.params.id !== undefined ? (
                              <FormControl
                                value={this.state.selectedSubscriberName}
                                readOnly
                                type="text"
                              />
                            ) : (
                              <div
                                onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                                className="Appy2"
                              >
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="subscriber"
                                  // value={this.state.subscriberItems.find(obj => obj.value == sub_id)}
                                  onChange={(value) =>
                                    this.onSubscriberChange(value)
                                  }
                                  options={this.state.subscriberItems}
                                  placeholder="Subscriber"
                                  noOptionsMessage={() =>
                                    "Type Name or Phone Number"
                                  }
                                />
                              </div>
                            )}
                            {this.state.subscriberError}
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Prescription</ControlLabel>
                            <br></br>
                            <input
                              style={{ display: "none" }}
                              id="selectImage"
                              type="file"
                              className="form-control"
                              multiple
                              name="selectedFile"
                              onChange={this.handleFileChange}
                            />
                            <Button
                              onClick={this.upload}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  this.state.selectedFile.length == 0
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {this.state.selectedFile.length == 0
                                ? "Choose File"
                                : "Change File"}
                            </Button>{" "}
                            &nbsp;&nbsp;
                          </FormGroup>
                          {this.state.selectedFileError}

                          <FormGroup>
                            <ControlLabel>Source </ControlLabel>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="source"
                              value={this.state.sourceValue}
                              onChange={(value) => {
                                this.handleSourceValue(value);
                              }}
                              placeholder="Select Source"
                              options={[
                                { value: "1", label: "Flash" },
                                { value: "2", label: "oPharma" },
                                { value: "3", label: "MyPharma" },
                                { value: "4", label: "Daraz" },
                                { value: "5", label: "Pickme" },
                                { value: "6", label: "E-channeling" },
                                { value: "7", label: "Uber" },
                                { value: "8", label: "Heart 2 Heart" },
                                { value: "9", label: "Vida" },
                                { value: "10", label: "PetDoc" },
                                { value: "11", label: "LankaRemit" },
                                { value: "12", label: "ComBankFlash" },
                                { value: "13", label: "LiweCommunities" },
                                { value: "14", label: "SynergyIt" },
                              ]}
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup>
                            <br></br>
                            <div
                              style={{ position: "relative", bottom: "5px" }}
                            >
                              <ControlLabel
                                style={{
                                  marginTop: "1px",
                                  borderTop: "5px",
                                }}
                              >
                                {" "}
                                Order Date
                              </ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{ placeholder: "Order Date" }}
                                defaultValue={new Date()}
                                closeOnSelect={true}
                                value={this.state.orderdate}
                                onChange={this.handleDateChange}
                              />
                            </div>
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Sales Rep </ControlLabel>
                            <select
                              name="sales_rep"
                              value={this.state.sales_rep}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="0">Select Sales Rep</option>
                              {this.state.sales_rep_data.map((sales_data) => (
                                <option value={sales_data.value}>
                                  {sales_data.label}
                                </option>
                              ))}
                            </select>
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Generic report file</ControlLabel>
                            <br />
                            <input
                              style={{ display: "none" }}
                              id="selectImage2"
                              type="file"
                              // value={x.selectedFile}
                              className="form-control"
                              multiple
                              name="selectedFile2"
                              onChange={this.handleFileChange2}
                            />
                            <Button
                              onClick={this.upload2}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  this.state.selectedFile2.length == 0
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {this.state.selectedFile2.length == 0
                                ? "Choose File"
                                : "Change File"}
                            </Button>{" "}
                            &nbsp;&nbsp;
                          </FormGroup>
                          {this.state.selectedFile2Error}

                          {this.state.sourceValue.value == 3 ? (
                            <FormGroup>
                              <ControlLabel style={{ marginTop: "0px" }}>
                                MyPharma Referance
                              </ControlLabel>
                              <FormControl
                                name="mypharmareferance"
                                style={{ marginTop: "-5px" }}
                                value={this.state.mypharmareferance}
                                onChange={(event) => {
                                  this.setState({
                                    mypharmareferance: event.target.value,
                                  });
                                }}
                                placeholder="Enter MyPharma Referance"
                                type="text"
                              />
                              {this.state.mypharmareferanceError}
                            </FormGroup>
                          ) : (
                            ""
                          )}

                          {this.state.sourceValue.value == 2 ? (
                            <FormGroup>
                              <ControlLabel
                                style={{ marginTop: "0px" }}
                                className="opharma"
                              >
                                oPharma Referance
                              </ControlLabel>
                              <FormControl
                                style={{ marginTop: "-5px" }}
                                name="opharmareferance"
                                value={this.state.opharmareferance}
                                onChange={(event) => {
                                  this.setState({
                                    opharmareferance: event.target.value,
                                  });
                                }}
                                placeholder="Enter oPharma Referance"
                                type="text"
                              />
                              {this.state.opharmareferanceError}
                            </FormGroup>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>

                    {this.state.subscriber != 0 ? (
                      <div
                        className="order_address_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Address
                            </h3>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            {(!this.state.address_id ||
                              Number(this.state.address_id) === 0) &&
                              this.state.addressline1Error && (
                                <small className="text-danger">
                                  Address is required.
                                </small>
                              )}
                            <Button
                              fill
                              onClick={this.addanother.bind(this)}
                              style={{
                                position: "absolute",
                                right: "0",
                                marginTop: "-35px",
                              }}
                            >
                              Add Another Address<i className="fa fa-plus"></i>
                            </Button>
                            {this.state.addressaccess == "1" ? (
                              <FormGroup>
                                <ControlLabel>Address Line 1</ControlLabel>
                                <FormControl
                                  name="addressline1"
                                  value={this.state.addressline1}
                                  onChange={(event) => {
                                    this.setState({
                                      addressline1: event.target.value,
                                      addressline1Error: null,
                                    });
                                  }}
                                  placeholder="Enter Address Line1"
                                  type="text"
                                />
                                {this.state.addressline1Error}

                                <ControlLabel style={{ display: "flex" }}>
                                  Address Line 2
                                </ControlLabel>
                                <FormControl
                                  name="addressline2"
                                  value={this.state.addressline2}
                                  onChange={(event) => {
                                    this.setState({
                                      addressline2: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter Address Line2"
                                  type="text"
                                />
                                <div>
                                  <ControlLabel>
                                    Enter the location coordinates
                                  </ControlLabel>
                                  <FormControl
                                    name="coordinates"
                                    type="text"
                                    placeholder="Enter your location"
                                    value={this.state.input || ""}
                                    onChange={this.handleInputLocationChange}
                                    onKeyDown={(e) => e.preventDefault()}
                                    onPaste={(e) => {
                                      e.persist();
                                      setTimeout(() => {
                                        const pastedValue = e.target.value;
                                        this.handleInputLocationChange({
                                          target: { value: pastedValue },
                                        });
                                      }, 0);
                                    }}
                                  />
                                  {this.state.latiAndLogitError}
                                </div>

                                <ControlLabel>Postal code</ControlLabel>
                                <FormControl
                                  name="postalcode"
                                  value={this.state.postalcode}
                                  onChange={(event) => {
                                    this.setState({
                                      postalcode: event.target.value,
                                    });
                                    // event.target.value === ""
                                    //   ? this.setState({
                                    //       postalcodeError: (
                                    //         <small className="text-danger">
                                    //           Postalcode is required.
                                    //         </small>
                                    //       )
                                    //     })
                                    //   : this.setState({ postalcodeError: null });
                                  }}
                                  placeholder="Enter Postal Code"
                                  type="number"
                                />
                                {this.state.postalcodeError}

                                <ControlLabel>Country</ControlLabel>
                                <select
                                  name="country"
                                  value={this.state.country}
                                  onChange={this.onChange}
                                  className="form-control"
                                >
                                  <option value="0">Select Country</option>
                                  {country_detail.map((country_data) => (
                                    <option value={country_data.id}>
                                      {country_data.country_name}
                                    </option>
                                  ))}
                                </select>
                                {this.state.countryError}
                                <br></br>

                                <ControlLabel>City</ControlLabel>
                                <select
                                  name="city"
                                  value={this.state.city}
                                  onChange={this.onChange}
                                  className="form-control"
                                >
                                  <option value="0">Select City</option>
                                  {this.state.city_info.map((city) => (
                                    <option value={city.id}>
                                      {city.city_name}
                                    </option>
                                  ))}
                                </select>
                                {this.state.cityError}
                              </FormGroup>
                            ) : (
                              ""
                            )}
                            {this.state.addressdata.length ? (
                              <div
                                style={{
                                  padding: "20px 0",
                                }}
                              >
                                {this.state.addressdata.map((add, indexk) =>
                                  add.is_active === 1 &&
                                  this.state.first_address == add.id ? (
                                    <p>
                                      {" "}
                                      <div
                                        style={{
                                          borderColor: "#D3D3D3",
                                        }}
                                      >
                                        <input
                                          name="addressradio"
                                          value={this.state.address_id}
                                          checked={
                                            this.state.address_id == add.id
                                          }
                                          onChange={this.addrssselect.bind(
                                            this,
                                            add.id,
                                            add.city
                                          )}
                                          type="radio"
                                        ></input>{" "}
                                        {add.address_line1},{add.address_line2}{" "}
                                        ,
                                        {this.state.city_info.map((city) => (
                                          <React.Fragment>
                                            {city.id == add.city
                                              ? city.city_name
                                              : ""}
                                          </React.Fragment>
                                        ))}{" "}
                                        ,
                                        {country_detail.map((country_data) => (
                                          <React.Fragment>
                                            {country_data.id == add.country_id
                                              ? country_data.country_name + ","
                                              : ""}{" "}
                                          </React.Fragment>
                                        ))}
                                        {add.postal_code}
                                      </div>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )
                                )}

                                {this.state.addressdata.length > 1 && (
                                  <div className="collapeable_addresses_list">
                                    <Collapsible
                                      trigger="View Other Addresses"
                                      transitionTime={200}
                                      onClosing={() => {
                                        this.setState({
                                          first_address: this.state.address_id,
                                        });
                                      }}
                                    >
                                      {this.state.addressdata.map(
                                        (add, indexk) =>
                                          add.is_active === 1 &&
                                          this.state.first_address != add.id ? (
                                            <p>
                                              {" "}
                                              <div
                                                style={{
                                                  borderColor: "#D3D3D3",
                                                }}
                                              >
                                                <input
                                                  name="addressradio"
                                                  value={this.state.address_id}
                                                  checked={
                                                    this.state.address_id ==
                                                    add.id
                                                  }
                                                  onChange={this.addrssselect.bind(
                                                    this,
                                                    add.id,
                                                    add.city
                                                  )}
                                                  type="radio"
                                                ></input>{" "}
                                                {add.address_line1},
                                                {add.address_line2} ,
                                                {this.state.city_info.map(
                                                  (city) => (
                                                    <React.Fragment>
                                                      {city.id == add.city
                                                        ? city.city_name
                                                        : ""}
                                                    </React.Fragment>
                                                  )
                                                )}{" "}
                                                ,
                                                {country_detail.map(
                                                  (country_data) => (
                                                    <React.Fragment>
                                                      {country_data.id ==
                                                      add.country_id
                                                        ? country_data.country_name +
                                                          ","
                                                        : ""}{" "}
                                                    </React.Fragment>
                                                  )
                                                )}
                                                {add.postal_code}
                                              </div>{" "}
                                            </p>
                                          ) : (
                                            ""
                                          )
                                      )}
                                    </Collapsible>
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.subscriber != 0 ? (
                      <div
                        className="order_medicine_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        <div className="order_items_header">
                          <div>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Order Items
                            </h3>
                          </div>
                          <div>
                            <Button onClick={this.handleAddClick}>
                              {" "}
                              <i className="fa fa-plus"></i> Add Report
                            </Button>
                            &nbsp;
                            <Button onClick={this.Add_New_Report.bind(this)}>
                              {" "}
                              <i className="fa fa-plus"></i> Add New Report
                            </Button>
                          </div>
                          &nbsp;&nbsp;&nbsp;
                          {this.state.isPackageHasClaimLabAllowed &&
                            isSuperAdmin && (
                              <div>
                                <FormGroup
                                  style={{
                                    flex: "3",
                                    textAlign: "end",
                                    marginTop: "35px",
                                    display: "flex",
                                  }}
                                >
                                  <Checkbox
                                    number="47"
                                    checked={this.state.isClaimableOrder}
                                    onClick={(e) =>
                                      this.handleMarkedAsClaimOrderOnChange(e)
                                    }
                                    label={
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          marginTop: "-1.5px",
                                        }}
                                      >
                                        &nbsp;&nbsp;Claim order
                                      </p>
                                    }
                                    disabled={
                                      this.state.selectedFile.length === 0
                                        ? true
                                        : false
                                    }
                                  ></Checkbox>
                                </FormGroup>
                              </div>
                            )}
                          <div
                            style={{
                              flex: "1",
                              textAlign: "end",
                            }}
                          >
                            <Button
                              onClick={this.opendiscountmodal.bind(this)}
                              style={{
                                color: "#2B3A41",
                              }}
                            >
                              <i className="fa fa-plus"></i> Add Discount{" "}
                            </Button>
                          </div>
                        </div>

                        <Row>
                          <Col md={12}>
                            {this.state.medicationloading ? (
                              <LoadingMedication />
                            ) : (
                              <div className="table-responsive">
                                <Table className="fl_order_details">
                                  <thead>
                                    <tr>
                                      <th style={{ paddingLeft: 0 }}>
                                        &nbsp;
                                        {/* <ControlLabel>Sr.No </ControlLabel> */}
                                      </th>
                                      <th style={{ paddingLeft: 0 }}>
                                        <ControlLabel>Sr.No </ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>Item type </ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>Item Name </ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>Unit Price </ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>Quantity </ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>Margin </ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>Report</ControlLabel>
                                      </th>
                                      <th>
                                        <ControlLabel>SubTotal </ControlLabel>
                                      </th>
                                      <th></th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {this.state.inputList.map((x, i) => {
                                      return (
                                        <tr>
                                          <td>
                                            {x.description !== "" &&
                                            this.state.isClaimableOrder ? (
                                              <input
                                                key={x.description}
                                                type="checkbox"
                                                onClick={(e) =>
                                                  this.handleClaimableCheckBoxOnClick(
                                                    x.description,
                                                    e.target.checked
                                                  )
                                                }
                                                // value={x.description}
                                                checked={x.isChecked}
                                              />
                                            ) : (
                                              <td>&nbsp;</td>
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              width: "min-content",
                                              paddingLeft: 0,
                                            }}
                                          >
                                            <FormControl
                                              name="srno"
                                              disabled="disabled"
                                              value={x.srno}
                                              onChange={(e) =>
                                                this.handleInputChange(e, i)
                                              }
                                              placeholder="1"
                                              type="text"
                                            />
                                          </td>
                                          <td style={{ width: "20%" }}>
                                            <select
                                              name="item_type"
                                              className="form-control"
                                              value={x.item_type}
                                              onChange={(e) =>
                                                this.handleInputChange(e, i)
                                              }
                                            >
                                              <option value="1">Package</option>
                                              <option value="2">Report</option>
                                            </select>
                                          </td>
                                          <td style={{ width: "40%" }}>
                                            <div
                                              onKeyUp={(e) =>
                                                this.inputOnChange(e, i)
                                              }
                                              className="Appy"
                                            >
                                              <Select
                                                className="react-select primary"
                                                classNamePrefix="react-select"
                                                name="description"
                                                value={
                                                  x.description === ""
                                                    ? ""
                                                    : x.selectmedication
                                                }
                                                onChange={(value) =>
                                                  this.handleSelectChange(
                                                    i,
                                                    value
                                                  )
                                                }
                                                options={x.LabItems}
                                                placeholder="Item Name"
                                                noOptionsMessage={() =>
                                                  "Type Item Name or Code"
                                                }
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <FormControl
                                              className="no-padding"
                                              name="unitprice"
                                              disabled="disabled"
                                              value={x.unitprice}
                                              onChange={(e) =>
                                                this.handleInputChange(e, i)
                                              }
                                              placeholder="0.00"
                                              type="number"
                                            />
                                          </td>
                                          <td>
                                            <FormControl
                                              className="no-padding"
                                              name="quantity"
                                              min={1}
                                              value={x.quantity}
                                              onChange={(e) =>
                                                this.handleInputChange(e, i)
                                              }
                                              placeholder="1"
                                              type="number"
                                            />
                                          </td>

                                          <td>
                                            {/* 
                                          <select
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                            name="margin_discount_sub_type"
                                            value={x.margin_discount_sub_type}
                                            className="form-control"
                                          >
                                            <option value="2">Flat rate</option>
                                            <option value="1">
                                              Percentange
                                            </option>
                                          </select> */}

                                            {x.margin_discount_sub_type == 2 ? (
                                              <FormControl
                                                className="no-padding"
                                                name="newmargin"
                                                value={x.newmargin}
                                                onChange={(e) =>
                                                  this.handleInputChange(e, i)
                                                }
                                                placeholder="1"
                                                type="number"
                                              />
                                            ) : (
                                              <FormControl
                                                className="no-padding"
                                                name="margin_discount_percentage"
                                                value={
                                                  x.margin_discount_percentage
                                                }
                                                onChange={(e) =>
                                                  this.handleInputChange(e, i)
                                                }
                                                placeholder="1"
                                                type="number"
                                              />
                                            )}
                                          </td>

                                          <td key={i}>
                                            <input
                                              style={{ display: "none" }}
                                              id={`rp_upload${x.f_index}`}
                                              type="file"
                                              // value={x.selectedFile}
                                              className={`form-control `}
                                              multiple
                                              name="selectedReportFile"
                                              onChange={(e) =>
                                                this.handleReportFileChange(
                                                  e,
                                                  x.f_index
                                                )
                                              }
                                              // value = {x.selectedReportFile}
                                            />
                                            <Button
                                              onClick={(e) =>
                                                this.reportupload(
                                                  `rp_upload${x.f_index}`
                                                )
                                              }
                                              style={{ color: "#2B3A41" }}
                                            >
                                              {" "}
                                              <i
                                                className={
                                                  x.selectedReportFile.length ==
                                                  0
                                                    ? "fa fa-upload"
                                                    : "fa fa-pencil fa-fw"
                                                }
                                              ></i>{" "}
                                              {/* {/ {(x.selectedReportFile.length == 0 )?'Choose File':'Change File'}  /} */}
                                            </Button>
                                          </td>
                                          <td>
                                            <FormControl
                                              className="no-padding"
                                              name="subtotal"
                                              disabled="disabled"
                                              value={x.subtotal}
                                              onChange={(e) =>
                                                this.handleInputChange(e, i)
                                              }
                                              placeholder="1"
                                              type="number"
                                            />
                                          </td>
                                          <td>
                                            <a
                                              href="javascript:void(0)"
                                              onClick={(e) =>
                                                this.handleRemoveClick(i)
                                              }
                                            >
                                              X
                                            </a>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                                {this.state.medicationaddError}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}

                    <Modal
                      show={this.state.showmediactonModal}
                      onHide={() =>
                        this.setState({ showmediactonModal: false })
                      }
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Report Details</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <input
                          style={{
                            width: "0px",
                            height: "0px",
                            border: "none",
                          }}
                          type="text"
                          ref={this.report_error}
                        />
                        {reporterrormessage.length != 0 && (
                          <div className=" alert alert-danger">
                            {reporterrormessage.map((data) => (
                              <React.Fragment>
                                <li>{data}</li>
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                        <FormGroup>
                          <ControlLabel>Report Name</ControlLabel>
                          <FormControl
                            name="reportname"
                            value={this.state.reportname}
                            onChange={(event) => {
                              this.setState({
                                reportname: event.target.value,
                              });
                              event.target.value === ""
                                ? this.setState({
                                    reportnameError: (
                                      <small className="text-danger">
                                        Report Name is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ reportnameError: null });
                            }}
                            placeholder="Enter Report Name"
                            type="text"
                          />
                          {this.state.reportnameError}
                        </FormGroup>

                        {/* {this.category_drop} */}
                        <FormGroup>
                          <ControlLabel>Package</ControlLabel>
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            placeholder="Package"
                            name="package"
                            closeMenuOnSelect={false}
                            isMulti
                            value={this.state.package}
                            onChange={(value) =>
                              this.setState({
                                package: value,
                              })
                            }
                            options={this.state.packageItems}
                          />

                          {/* {this.state.packageError}        */}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Unit Price</ControlLabel>
                          <FormControl
                            name="unit_price"
                            value={this.state.unit_price}
                            onChange={(event) => {
                              this.setState({
                                unit_price: event.target.value,
                              });
                              event.target.value === ""
                                ? this.setState({
                                    unit_priceError: (
                                      <small className="text-danger">
                                        Unit Price is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ unit_priceError: null });
                            }}
                            placeholder="Enter Unit Price"
                            type="number"
                          />
                          {this.state.unit_priceError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Price</ControlLabel>
                          <FormControl
                            name="price"
                            value={this.state.price}
                            onChange={(event) => {
                              this.setState({ price: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    priceError: (
                                      <small className="text-danger">
                                        Price is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ priceError: null });
                            }}
                            placeholder="Enter Price"
                            type="number"
                          />
                          {this.state.priceError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Test Code</ControlLabel>
                          <FormControl
                            name="test_code"
                            value={this.state.test_code}
                            onChange={(event) => {
                              this.setState({
                                test_code: event.target.value,
                              });
                              event.target.value === ""
                                ? this.setState({
                                    test_codeError: (
                                      <small className="text-danger">
                                        TestCode is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ test_codeError: null });
                            }}
                            placeholder="Enter test code"
                            type="number"
                          />
                          {this.state.test_codeError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Description </ControlLabel>
                          <textarea
                            name="description"
                            value={this.state.description}
                            onChange={(event) => {
                              this.setState({
                                description: event.target.value,
                              });
                            }}
                            placeholder="Enter Description"
                            className="form-control"
                            rows={2}
                            cols={3}
                          ></textarea>
                        </FormGroup>
                        <FormGroup className="">
                          <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                          <div className="report_feature">
                            <Radio
                              number="12"
                              option="1"
                              name="is_featured"
                              onChange={this.onChange}
                              checked={this.state.is_featured === "1"}
                              label="Yes"
                            />{" "}
                            &nbsp;
                            <Radio
                              number="13"
                              option="2"
                              name="is_featured"
                              onChange={this.onChange}
                              checked={this.state.is_featured === "2"}
                              label="No"
                            />
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Department Name</ControlLabel>
                          <select
                            className="form-control"
                            name="Dept_Name"
                            value={this.state.Dept_Name}
                            onChange={(event) => {
                              this.setState({
                                Dept_Name: event.target.value,
                              });
                              event.target.value === "0"
                                ? this.setState({
                                    Dept_NameError: (
                                      <small className="text-danger">
                                        Department Name is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ Dept_NameError: null });
                            }}
                          >
                            <option value="0">Select Department</option>
                            {this.state.Dept_details.map((dept) => (
                              <option value={dept.id}>
                                {dept.department_name}
                              </option>
                            ))}
                          </select>
                          {this.state.Dept_NameError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Parent Test</ControlLabel>
                          <FormControl
                            name="Parent_Test"
                            value={this.state.Parent_Test}
                            onChange={(event) => {
                              this.setState({
                                Parent_Test: event.target.value,
                              });
                              // event.target.value === ""
                              //   ? this.setState({
                              //     Parent_TestError: (
                              //         <small className="text-danger">
                              //           Parent Test is required.
                              //         </small>
                              //       )
                              //     })
                              //   : this.setState({ Parent_TestError: null });
                            }}
                            placeholder="Enter Parent Test"
                            type="text"
                          />
                          {/* {this.state.Parent_TestError} */}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Short Name</ControlLabel>
                          <FormControl
                            name="Short_Name"
                            value={this.state.Short_Name}
                            onChange={(event) => {
                              this.setState({
                                Short_Name: event.target.value,
                              });
                            }}
                            placeholder="Enter Short Name"
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Display Name</ControlLabel>
                          <FormControl
                            name="Display_Name"
                            value={this.state.Display_Name}
                            onChange={(event) => {
                              this.setState({
                                Display_Name: event.target.value,
                              });
                            }}
                            placeholder="Enter Display Name"
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Method Name</ControlLabel>
                          <FormControl
                            name="Method_Name"
                            value={this.state.Method_Name}
                            onChange={(event) => {
                              this.setState({
                                Method_Name: event.target.value,
                              });
                            }}
                            placeholder="Enter Method Name"
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Specimen Name</ControlLabel>
                          <FormControl
                            name="Specimen_Name"
                            value={this.state.Specimen_Name}
                            onChange={(event) => {
                              this.setState({
                                Specimen_Name: event.target.value,
                              });
                            }}
                            placeholder="Enter Specimen Name"
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Cointainer Name</ControlLabel>
                          <FormControl
                            name="Container_Name"
                            value={this.state.Container_Name}
                            onChange={(event) => {
                              this.setState({
                                Container_Name: event.target.value,
                              });
                            }}
                            placeholder="Enter Container Name"
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Minmum Process Time</ControlLabel>
                          <InputMask
                            mask="99:99"
                            className="form-control"
                            placeholder="12:00"
                            name="Min_Process_Time"
                            onChange={(event) => {
                              this.setState({
                                Min_Process_Time: event.target.value,
                              });
                            }}
                            value={this.state.Min_Process_Time}
                            maskChar=" "
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Emergency Process Time</ControlLabel>
                          <InputMask
                            mask="99:99"
                            className="form-control"
                            placeholder="12:00"
                            name="Emergency_Process_Time"
                            onChange={(event) => {
                              this.setState({
                                Emergency_Process_Time: event.target.value,
                              });
                            }}
                            value={this.state.Emergency_Process_Time}
                            maskChar=" "
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Reporting Days</ControlLabel>
                          <FormControl
                            name="Reporting_Days"
                            value={this.state.Reporting_Days}
                            onChange={(event) => {
                              this.setState({
                                Reporting_Days: event.target.value,
                              });
                            }}
                            placeholder="Enter Reporting Days"
                            min={1}
                            type="number"
                          />
                        </FormGroup>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          className="btn-color"
                          fill
                          onClick={this.add_new_report_data.bind(this)}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>

                    <div
                      className="order_middle_container"
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        padding: "0 20px 20px 20px",
                      }}
                    >
                      <Row>
                        <Col md={3} sm={3}>
                          <FormGroup className="fl_datepicker">
                            <ControlLabel>Collection Date</ControlLabel>
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              inputProps={{
                                placeholder: "Collection Date",
                              }}
                              defaultValue={new Date()}
                              closeOnSelect={true}
                              value={this.state.deliverydate}
                              onChange={this.handledeliveryDate}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3} sm={3}>
                          <FormGroup>
                            <ControlLabel>Collection Time Slot</ControlLabel>
                            <select
                              style={{ margin: "0.4rem" }}
                              name="deliverytimeslot"
                              onChange={this.onChange}
                              value={this.state.deliverytimeslot}
                              className="form-control"
                            >
                              <option value="">
                                Select Collection Time Slot
                              </option>
                              <option value="7:00 AM - 9:00 AM">
                                7:00 AM - 9:00 AM
                              </option>
                              <option value="9.00 AM - 11.00 AM">
                                9.00 AM - 11.00 AM
                              </option>
                              <option value="11.00 AM - 1.00 PM">
                                11.00 AM - 1.00 PM
                              </option>
                              <option value="1.00 PM - 3.00 PM">
                                1.00 PM - 3.00 PM
                              </option>
                              <option value="3.00 PM - 5.00 PM">
                                3.00 PM - 5.00 PM
                              </option>
                            </select>
                            {this.state.deliverytimeslotError}
                          </FormGroup>
                        </Col>

                        <Col md={3} sm={3}>
                          <FormGroup>
                            <ControlLabel style={{ marginBottom: "0.9rem" }}>
                              Payment Option
                            </ControlLabel>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Payment Option"
                              //style={{ width:"10%" }}
                              name="paymentoption"
                              value={this.state.paymentoption}
                              onChange={(value) =>
                                this.setState({
                                  paymentoption: value,
                                })
                              }
                              options={[
                                { value: "Cash", label: "Cash" },
                                // { value: "Card", label: "Card" },
                                { value: "Cheque", label: "Cheque" },
                                {
                                  value: "Bank Transfer",
                                  label: "Bank Transfer",
                                },
                                { value: "Hybrid", label: "Hybrid" },
                                { value: "ComBank", label: "ComBank" },
                              ]}
                            />
                            {this.state.paymentoptionError}
                          </FormGroup>
                        </Col>
                        <Col md={3} sm={3}>
                          <FormGroup className="fl_datepicker">
                            <div style={{ bottom: "5px" }}>
                              <ControlLabel> Payment Due Date</ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{
                                  placeholder: "Payment Due Date",
                                }}
                                defaultValue={new Date()}
                                closeOnSelect={true}
                                value={this.state.paymentduedate}
                                onChange={this.handlePaymentDueDate}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={3} sm={3}>
                          <FormGroup>
                            <ControlLabel>Health Condition</ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="HealthCondition"
                              name="healthcondition"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.healthcondition}
                              onChange={(value) =>
                                this.setState({
                                  healthcondition: value,
                                })
                              }
                              options={this.state.healthconditionItems}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3} sm={3}>
                          <FormGroup className="fl_datepicker">
                            <ControlLabel>Rider : </ControlLabel>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Rider"
                              name="rider_id"
                              value={this.state.rider_id}
                              onChange={(value) =>
                                this.setState({
                                  rider_id: value,
                                })
                              }
                              options={this.state.rider_data}
                            />
                            {this.state.rider_idError}
                          </FormGroup>
                        </Col>
                        <Col md={3} sm={3}>
                          <FormGroup className="fl_datepicker">
                            <ControlLabel>Partners </ControlLabel>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Partners"
                              name="labPartnerName"
                              value={this.state.labPartnerName}
                              onChange={(value) =>
                                this.onLaborderPartnerOnchange(value)
                              }
                              options={this.state.labPartnerOptions}
                            />
                          </FormGroup>
                        </Col>
                        {/*<Col md={3} sm={3}>
                        <FormGroup>
                          {this.state.dynamicfinalpercentage != 0 ? (
                            <p style={{ marginTop: "26px" }}>
                              {" "}
                              Added Discount :
                              {this.state.dynamicfinalpercentage}
                            </p>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>*/}
                      </Row>

                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <ControlLabel>Note</ControlLabel>
                            <textarea
                              className="form-control"
                              rows="4"
                              cols="5"
                              placeholder="Enter Note"
                              onChange={(event) => {
                                this.setState({
                                  ordernote: event.target.value,
                                });
                              }}
                              value={this.state.ordernote}
                            ></textarea>
                          </FormGroup>
                        </Col>
                        <Col sm={12}>
                          <FormGroup>
                            <Checkbox
                              number="46"
                              checked={this.state.show_instruction1}
                              onChange={this.handleshow_instruction1}
                              label="Please stop taking any fluids and solids except water for 12 hours"
                            ></Checkbox>
                          </FormGroup>
                        </Col>
                        <Col sm={12}>
                          <FormGroup>
                            <Checkbox
                              number="47"
                              checked={this.state.show_instruction2}
                              onChange={this.handleshow_instruction2}
                              label="For Fasting blood sugar please fast as a guideline for 10 to 12 hours"
                            ></Checkbox>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    <div
                      className="order_middle_sub_container"
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        padding: "20px",
                      }}
                    >
                      <Row>
                        <Col md={4} sm={4}>
                          <FormGroup>
                            <ControlLabel>Purpos of Testing </ControlLabel>
                            <Radio
                              style={{ display: "inline-block" }}
                              number="21"
                              option="travelling"
                              name="purposoftesting"
                              onChange={this.onChange}
                              checked={
                                this.state.purposoftesting === "travelling"
                              }
                              label="Travelling"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="22"
                              option="employment"
                              name="purposoftesting"
                              onChange={this.onChange}
                              checked={
                                this.state.purposoftesting === "employment"
                              }
                              label="Employment"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="23"
                              option="hospital_admission"
                              name="purposoftesting"
                              onChange={this.onChange}
                              checked={
                                this.state.purposoftesting ===
                                "hospital_admission"
                              }
                              label="Hospital Admission"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="24"
                              option="screening"
                              name="purposoftesting"
                              onChange={this.onChange}
                              checked={
                                this.state.purposoftesting === "screening"
                              }
                              label="Screening"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} sm={4}>
                          <FormGroup>
                            <ControlLabel>Institute</ControlLabel>
                            <FormControl
                              type="text"
                              name="institute"
                              value={this.state.institute}
                              onChange={this.onChange}
                            ></FormControl>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Name of the collector</ControlLabel>
                            <FormControl
                              type="text"
                              name="nameofcollector"
                              value={this.state.nameofcollector}
                              onChange={this.onChange}
                            ></FormControl>
                          </FormGroup>
                        </Col>
                        <Col md={4} sm={4}>
                          <FormGroup>
                            <ControlLabel>Patient's condition </ControlLabel>
                            <Radio
                              style={{ display: "inline-block" }}
                              number="25"
                              option="symptomatic"
                              name="partialcondition"
                              onChange={this.onChange}
                              checked={
                                this.state.partialcondition === "symptomatic"
                              }
                              label="Symptomatic"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="26"
                              option="asymptomatic"
                              name="partialcondition"
                              onChange={this.onChange}
                              checked={
                                this.state.partialcondition === "asymptomatic"
                              }
                              label="Asymptomatic"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4} sm={4}>
                          <FormGroup>
                            <ControlLabel>Sample Type</ControlLabel>
                            <Radio
                              style={{ display: "inline-block" }}
                              number="27"
                              option="blood"
                              name="sampletype"
                              onChange={this.onChange}
                              checked={this.state.sampletype === "blood"}
                              label="Blood"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="28"
                              option="nasopharyngeal_oropharyngeal_swab"
                              name="sampletype"
                              onChange={this.onChange}
                              checked={
                                this.state.sampletype ===
                                "nasopharyngeal_oropharyngeal_swab"
                              }
                              label="Nasopharyngeal oropharyngeal swab"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} sm={4}>
                          <FormGroup>
                            <ControlLabel>
                              Place of Sample Collection{" "}
                            </ControlLabel>
                            <Radio
                              style={{ display: "inline-block" }}
                              number="29"
                              option="main_lab"
                              name="placeofsamplecolletion"
                              onChange={this.onChange}
                              checked={
                                this.state.placeofsamplecolletion === "main_lab"
                              }
                              label="Main lab"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="30"
                              option="branch"
                              name="placeofsamplecolletion"
                              onChange={this.onChange}
                              checked={
                                this.state.placeofsamplecolletion === "branch"
                              }
                              label="Branch"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="31"
                              option="outside"
                              name="placeofsamplecolletion"
                              onChange={this.onChange}
                              checked={
                                this.state.placeofsamplecolletion === "outside"
                              }
                              label="Outside"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4} sm={4}>
                          <FormGroup>
                            <ControlLabel>Mode of Transportation </ControlLabel>
                            <Radio
                              style={{ display: "inline-block" }}
                              number="32"
                              option="vtm"
                              name="modeoftransportation"
                              onChange={this.onChange}
                              checked={
                                this.state.modeoftransportation === "vtm"
                              }
                              label="Vtm"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="33"
                              option="in_ice"
                              name="modeoftransportation"
                              onChange={this.onChange}
                              checked={
                                this.state.modeoftransportation === "in_ice"
                              }
                              label="In Ice"
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col sm={12}>
                          <Button
                            disabled={!this.state.processing}
                            onClick={this.onSubmit.bind(this)}
                            className="btn-color" //bsStyle="info"
                            fill
                          >
                            Submit
                          </Button>{" "}
                          &nbsp;
                          <Button
                            disabled={!this.state.processing}
                            onClick={this.onSendQuote.bind(this)}
                            className="btn-color" //bsStyle="info"
                            fill
                          >
                            Submit Quote
                          </Button>
                        </Col>
                      </Row>
                    </div>

                    <Modal
                      show={this.state.showModal}
                      onHide={() => this.setState({ showModal: false })}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Item Details</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p key={subscriptiondetail.id}>
                          {" "}
                          TotalCost :{" "}
                          {(subscriptiondetail.total_cost - 0).toFixed(2)}
                        </p>

                        <p>
                          Delivery Type :{" "}
                          {subscriptiondetail.delivery_type == "1"
                            ? "Flash"
                            : ""}
                        </p>
                        {subscriptiondetail.delivery_charge != null ? (
                          <p>
                            Delivery Charge :{" "}
                            {(subscriptiondetail.delivery_charge - 0).toFixed(
                              2
                            )}
                          </p>
                        ) : (
                          ""
                        )}
                        {subscriptiondetail.organization_discount > 0 ? (
                          <p>
                            Discount :{" "}
                            {(
                              subscriptiondetail.organization_discount - 0
                            ).toFixed(2)}
                          </p>
                        ) : (
                          ""
                        )}

                        <Table>
                          <thead>
                            <tr>
                              <th>Item Name</th>
                              <th>Price</th>
                              <th>Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.medication_detail.length != 0 ? (
                              <>
                                {this.state.medicationdataList.map((data) => (
                                  <tr>
                                    {/* <td key={data.id}>{data.report_title}</td> */}
                                    <td>{data.report_title}</td>
                                    <td>{(data.unit_price - 0).toFixed(2)}</td>
                                    <td>{data.quantity}</td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              ""
                            )}
                          </tbody>
                        </Table>
                      </Modal.Body>
                    </Modal>

                    <Row
                      style={{
                        padding: "0 20px",
                      }}
                    >
                      <Col sm={12} className="collapeablecomp_orderhistory">
                        <Collapsible
                          trigger="Historical Lab Orders"
                          transitionTime={200}
                        >
                          {" "}
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Order Date</th>
                                <th>Total Cost</th>
                                <th className="text-right">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {this.state.lastsubscription.map((lastd) => (
                                    <tr>
                                      <td>{lastd.lead["name"]}</td>
                                      <td>{lastd.order_date}</td>
                                      <td>
                                        {(lastd.total_cost - 0).toFixed(2)}
                                      </td>
                                      <td className="text-right">
                                        {" "}
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={view}
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            onClick={this.lastorderdetail.bind(
                                              this,
                                              lastd.id
                                            )}
                                            bsSize="xm"
                                          >
                                            <i className="fa fa-user" />
                                          </Button>
                                        </OverlayTrigger>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </Collapsible>
                      </Col>
                    </Row>
                  </Col>

                  {this.state.subscriber != 0 ? (
                    <Col
                      sm={4}
                      className="fl_sticky_side orderStatic-container labOrder_staticsidebar"
                    >
                      <div className="dropdown-AddOrder">
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                                marginBottom: "20px",
                              }}
                            >
                              Customer Info
                            </h3>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <div className="table-responsive ">
                              <table className="table">
                                <tbody>
                                  {/* <React.Fragment> */}
                                  <tr>
                                    <td className="text-left">Name</td>
                                    <td
                                      className="text-right"
                                      style={{ padding: "1px" }}
                                    >
                                      {this.state.username != null
                                        ? this.state.username
                                        : "-"}
                                    </td>
                                  </tr>
                                  {/*<tr>
                                  <td className="text-left">Phone Number</td>
                                  <td
                                    className="text-right"
                                    style={{ padding: "1px" }}
                                  >
                                    {this.state.userphone != null
                                      ? this.state.userphone
                                      : "-"}
                                  </td>
                                    </tr>*/}
                                  <tr>
                                    <td className="text-left">Mobile Number</td>
                                    <td
                                      className="text-right"
                                      style={{ padding: "1px" }}
                                    >
                                      {this.state.usermobile != null
                                        ? this.state.usermobile
                                        : "-"}
                                    </td>
                                  </tr>
                                  {this.state.useremail && (
                                    <tr>
                                      <td className="text-left">
                                        Email Address
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.useremail != null
                                          ? this.state.useremail
                                          : "-"}
                                      </td>
                                    </tr>
                                  )}
                                  {this.state.isClaimableOrder ? (
                                    <tr>
                                      <td className="text-left">
                                        Claim credits
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state
                                          .availableTotalClaimCredits != null
                                          ? (
                                              this.state
                                                .availableTotalClaimCredits - 0
                                            ).toFixed(2)
                                          : "0"}
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr>
                                      <td className="text-left">
                                        Remaining Credits
                                      </td>
                                      <td
                                        className="text-right"
                                        style={{ padding: "1px" }}
                                      >
                                        {this.state.avalable_flash_point != null
                                          ? (
                                              this.state.avalable_flash_point -
                                              0
                                            ).toFixed(2)
                                          : "0"}
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td className="text-left">Company Name</td>
                                    <td
                                      className="text-right"
                                      style={{ padding: "1px" }}
                                    >
                                      {this.state.companyname != null
                                        ? this.state.companyname
                                        : "-"}
                                    </td>
                                  </tr>
                                  {this.state.isClaimableOrder ? (
                                    <tr>
                                      <td
                                        colSpan="2"
                                        className="collapeablecomp_orderhistory"
                                      >
                                        {/* <Col md={12} className="collapeablecomp_orderhistory"> */}
                                        <Collapsible
                                          trigger="Policy Details"
                                          transitionTime={200}
                                          onOpen={() => {
                                            this.showPolicyDetails();
                                          }}
                                        >
                                          <div>
                                            <p>
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    this.state
                                                      .ClaimPolicyDetails,
                                                }}
                                              ></div>
                                            </p>
                                          </div>
                                        </Collapsible>
                                        {/* </Col> */}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <div className="dropdown2-AddOrder">
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "20px 0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Basket Info
                            </h3>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <div className="table-responsive ">
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Basket Value
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.basketvalue}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Discounted Amount
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.discountamount > 0
                                          ? "-"
                                          : ""}{" "}
                                        {this.state.discountamount}
                                      </p>
                                    </td>
                                  </tr>
                                  {this.state.catPackageDiscountAmount != 0 && (
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        {`${this.state.catalougepackagename} Package Discount Amount (${this.state.catPackageDiscount}%)`}
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <p className="basketValue_parent">
                                          {this.state.catPackageDiscountAmount >
                                          0
                                            ? "-"
                                            : ""}{" "}
                                          {this.state.catPackageDiscountAmount}
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Service Charge
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <FormControl
                                        name="deliverycharge"
                                        className="basketValue_input fl_deliverycharge"
                                        value={this.state.deliverycharge}
                                        onChange={this.onChange}
                                        placeholder="0.00"
                                        type="number"
                                      />
                                    </td>
                                  </tr>
                                  {this.claimableTotal != 0 ? (
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        Claimed Value
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <p className="basketValue_parent">
                                          {this.handleClaimedValueOnChange()}
                                        </p>
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Total Cost
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basket_totalcost">
                                        {this.state.totalcost}
                                      </p>
                                      {/*<FormControl
                                      name="totalcost"
                                      className="fl_total_cost_inpt fl_basketinfoupdated"
                                      disabled="disabled"
                                      value={
                                        this.state.loading ? (
                                          <LoadingSpinner />
                                        ) : (
                                          this.state.totalcost
                                        )
                                      }
                                      onChange={(event) => {
                                        this.setState({
                                          totalcost: event.target.value,
                                        });
                                        event.target.value === ""
                                          ? this.setState({
                                              totalcostError: (
                                                <small className="text-danger">
                                                  Total Cost is required.
                                                </small>
                                              ),
                                            })
                                          : this.setState({
                                              totalcostError: null,
                                            });
                                      }}
                                      placeholder="0.00"
                                      type="number"
                                    />*/}
                                      {this.state.totalcostError}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </>
            }
          />
        </Grid>

        <Modal
          show={this.state.discountmodal}
          onHide={() => this.setState({ discountmodal: true })}
        >
          <Modal.Header>
            <Modal.Title>Dynamic Discount</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Discount Amount</ControlLabel>
              <FormControl
                type="text"
                value={this.state.discountpercentage}
                onChange={this.onChange}
                name="discountpercentage"
                placeholder="0"
              ></FormControl>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.submitdynamicdiscount.bind(this)}
              className="btn-color"
              fill
            >
              Submit
            </Button>
            &nbsp;
            <Button
              onClick={this.closedynamicdiscount.bind(this)}
              className="btn-color"
              fill
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.marginmodal}
          onHide={() => this.setState({ marginmodal: false })}
        >
          <Modal.Header>
            <Modal.Title>Dynamic Margin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup className="order_source_data">
              <ControlLabel>Select Margin Type</ControlLabel>
              &nbsp;
              <Radio
                style={{ display: "inline-block" }}
                number="8"
                option="1"
                name="margintype"
                onChange={this.onChange}
                checked={this.state.margintype === "1"}
                label="Margin Percentage"
              />
              &nbsp;
              <Radio
                style={{ display: "inline-block" }}
                number="9"
                option="2"
                name="margintype"
                onChange={this.onChange}
                checked={this.state.margintype === "2"}
                label="Margin in cash"
              />
            </FormGroup>

            {this.state.margintype == 1 ? (
              <FormGroup>
                <ControlLabel>Margin Percentage</ControlLabel>
                <FormControl
                  type="number"
                  onChange={this.onChange}
                  value={this.state.marginpercentage}
                  name="marginpercentage"
                  placeholder="0%"
                ></FormControl>
              </FormGroup>
            ) : (
              ""
            )}
            {this.state.margintype == 2 ? (
              <FormGroup>
                <ControlLabel>Margin Amount</ControlLabel>
                <FormControl
                  type="number"
                  onChange={this.onChange}
                  value={this.state.marginamount}
                  name="marginamount"
                  placeholder="0.00"
                ></FormControl>
              </FormGroup>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.submitdynamicmargin.bind(this)}
              bsStyle="success"
              fill
            >
              {" "}
              Submit
            </Button>{" "}
            &nbsp;
            <Button
              onClick={this.closedynamicmargin.bind(this)}
              bsStyle="info"
              fill
            >
              {" "}
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.reportmodal}
          onHide={() => this.setState({ reportmodal: true })}
        >
          <Modal.Header>
            <Modal.Title>Upload Report Files</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Report Files</ControlLabel>
              {this.state.inputList.map((x, i) => (
                <>
                  {/* <input 
                                style={{display: 'none'}}
                                id='selectreportImage' 
                                type="file" 
                                // value={x.selectedFile}
                                className="form-control" 
                                multiple
                                name="selectedReportFile"  
                                onChange={e => this.handleReportFileChange(e,i)} 
                                 />
                                   <Button  
                                   onClick={this.reportupload} 
                                   style={{ color: "#2B3A41" }} > 
                                   {" "} <i className={(this.state.selectedReportFile.length == 0 )?"fa fa-plus":"fa fa-pencil fa-fw"}></i> {" "}
                                    {(this.state.selectedReportFile.length == 0 )?'Choose File':'Change File'} 
                                   </Button> &nbsp;&nbsp; */}
                </>
              ))}
              {this.state.selectedReportFileError}
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.submitreportmodal.bind(this)}
              className="btn-color"
              fill
            >
              Submit
            </Button>
            &nbsp;
            <Button
              onClick={this.closereportmodal.bind(this)}
              className="btn-color"
              fill
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}

export default addlaborder;
